import React, {Component} from 'react';
import {Button, Card, CardBody, CardSubtitle, Col, Row, UncontrolledTooltip} from 'reactstrap';
import Swal from 'sweetalert2';
import _ from 'lodash';

import Select from "../../local_node_modules/react-select"
import '../../local_node_modules/react-select/dist/react-select.css';

import moment from 'moment';
import Alert from "react-s-alert";
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import NumberFormat from 'react-number-format';

import {Decimal} from 'decimal.js';
import 'moment/locale/tr';
import InvoiceLines from "./component/InvoiceLines";
import TotalList from "../voucher/component/TotalList";
import NoteList from "../voucher/component/NoteList";
import InvoiceType from "./component/InvoiceType";
import InformationPanel from "./component/InformationPanel";
import TouristInfo from "./component/TouristInfo";
import ForeignCompanyInfo from "./component/ForeignCompanyInfo";
import {validateField} from "../../common/validation";
import {deepCopyObject, hasUserRight, showAxiosError} from "../../helper/helper";
import ExternalCustomer from "../voucher/component/ExternalCustomer";
import {isValidInvoice} from "../../common/componentValidation";
import {getExemptions, onSwitchExtCustomer, whenInvoiceTypeChange} from "../../helper/invoiceHelper";
import {request} from "../../helper/APIUtils";
import ReactLoadingTop from "../../components/ReactLoadingTop";
import NavBarKS from "../../components/NavBarKS";
import StickButton from "../../components/StickButton";
import NoIdentifier from "./component/NoIdentifier";
import MediaViewer from "../einvoice/MediaViewer";
import DefaultModal from "./DefaultModal";
import DepoIade from "./component/depo/iade/DepoIade";
import {hasDepoIade} from "./SpecialFunctionalities";
import {predefinedButtonFilter, predefinedInvoiceTypes} from "./PredefinedInvoiceTypes";
import SweetAlert from "react-bootstrap-sweetalert";
import {
	checkIade,
	checkNavlun, connectorPaymentExceptionUser,
	showConnector,
	showConnectorPayment,
	showPredefinedBtn
} from "../../helper/permission";
import {DocumentFrom, EntegratorIdentifiers, UserRightsEnum} from "../../helper/enums";
import cacheInstance from '../../components/cache/Cache'
import {EntegratorConf, VirtualHost} from "../../constants";
import ConnectorModal from "../connector/ConnectorModal";
import ConnectorExternalCustomer from "./component/ConnectorExternalCustomer";
import {uuidGenerator} from "../connector/erpHelper";
import CustomaryPriceModal from "../connector/CustomaryPriceModal";
import InvoiceIadeLine from "./component/InvoiceIadeLine";
import ConnectorPaymentModal from "../connector/ConnectorPaymentModal";
import Select2, {Option} from "rc-select";

class CreateEditInvoice extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: {},
			saveLoading: false,
			isFree: false,
			activeTab: "temelbilgiler",
			saveType: "saveClose",
			manual: false,
			approveAsDespatch: false,
			isGocIdaresi: false,
			periods: [],
			iade: false,
			totalCosts: 0,
			isUpdateScenario: false,
			filteredXslts: [],
			newPreDefined: null,
			predefinedInvoiceType:null,
			showOrderManagerLineNum: false,
			gekAlert: null,
			manualInput: false,
			customaryPriceModal: false,
			connectorPaymentModal: false,
			iadeLine: [],
			userDefinition: {},
			propType: null,
			checkConnectorUpdated: false,
			checkConnectorInstallation: false,
			connectorAlert: false
		};

		this.errorListener = this.errorListener.bind(this);
		this.invoiceTypeListener = this.invoiceTypeListener.bind(this);
		this.setExternalCustomer = this.setExternalCustomer.bind(this);
		this.setTrdDocInvoiceLines = this.setTrdDocInvoiceLines.bind(this);
		this.validateField = this.validateField.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChangeValue = this.onChangeValue.bind(this);
		this.onIsFree = this.onIsFree.bind(this);
		this.setTrdDocInvoiceNotes = this.setTrdDocInvoiceNotes.bind(this);
		this.setTrdDocInvoiceDespatchReferences = this.setTrdDocInvoiceDespatchReferences.bind(this);
		this.setTrdDocInvoiceInternetSales = this.setTrdDocInvoiceInternetSales.bind(this);
		this.setTrdDocInvoiceCarrierParty = this.setTrdDocInvoiceCarrierParty.bind(this);
		this.setDocExternalCustomer = this.setDocExternalCustomer.bind(this);
		this.setTouristInfo = this.setTouristInfo.bind(this);
		this.setTrdDocInvoiceTaxRepresentativeParty = this.setTrdDocInvoiceTaxRepresentativeParty.bind(this);
		this.setOrderReference = this.setOrderReference.bind(this);
		this.setSGKInfo = this.setSGKInfo.bind(this);
		this.setPaymentInfo = this.setPaymentInfo.bind(this);
		this.clearPaymentInfo = this.clearPaymentInfo.bind(this);
		this.toggle = this.toggle.bind(this);
		this.saveDocument = this.saveDocument.bind(this);
		this.getInitInvoice = this.getInitInvoice.bind(this);
		this.isManual = this.isManual.bind(this);
		this.getXSLT = this.getXSLT.bind(this);
		this.filterXSLTs = this.filterXSLTs.bind(this);
		this.getSourceUrn = this.getSourceUrn.bind(this);
		this.sendIncorrectInvoice = this.sendIncorrectInvoice.bind(this);
		this.isKamu = this.isKamu.bind(this);
		this.showDocument = this.showDocument.bind(this);
		this.setMediaViewer = this.setMediaViewer.bind(this);
		this.confirmSend = this.confirmSend.bind(this);
		this.handleSend = this.handleSend.bind(this);
		this.changeKDV = this.changeKDV.bind(this);
		this.setGocIdaresi = this.setGocIdaresi.bind(this);
		this.setMedulaOptik = this.setMedulaOptik.bind(this);
		this.costsListener = this.costsListener.bind(this);
		this.calculateTotalCosts = this.calculateTotalCosts.bind(this);
		this.preventNull = this.preventNull.bind(this);
		this.updatePeriodList = this.updatePeriodList.bind(this);
		this.getPeriods = this.getPeriods.bind(this);
		this.calculateCost = this.calculateCost.bind(this);
		this.checkUserRights = this.checkUserRights.bind(this);
		this.renderPredefinedButtons = this.renderPredefinedButtons.bind(this);
		this.setPredefinedType = this.setPredefinedType.bind(this);
		this.updateScenario = this.updateScenario.bind(this);
		this.checkIfGibUser = this.checkIfGibUser.bind(this);
		this.renderExternalCustomerPopup = this.renderExternalCustomerPopup.bind(this);
		this.setAdditionalDocument = this.setAdditionalDocument.bind(this);
		this.renderAlertMessage = this.renderAlertMessage.bind(this);
		this.setExternalCustomerAsync = this.setExternalCustomerAsync.bind(this);
		this.setOdemeYapacakAlici = this.setOdemeYapacakAlici.bind(this);
		this.checkLocationChange = this.checkLocationChange.bind(this);
		this.initialization = this.initialization.bind(this);
		this.fetchPredefinedInvoiceForUser = this.fetchPredefinedInvoiceForUser.bind(this);
		this.renderGekAlert = this.renderGekAlert.bind(this);
		this.prepareGekAlert = this.prepareGekAlert.bind(this);
		this.invoiceTypeListenerCallbacks = this.invoiceTypeListenerCallbacks.bind(this);
		this.setExternalCustomerCallbacks = this.setExternalCustomerCallbacks.bind(this);
		this.switchManualInput = this.switchManualInput.bind(this);
		this.setLoadingBank = this.setLoadingBank.bind(this);
		this.onChangeDateAndCurrency = this.onChangeDateAndCurrency.bind(this);
		this.checkCustomaryPrice = this.checkCustomaryPrice.bind(this);
		this.setTrdDocInvoiceIadeLines = this.setTrdDocInvoiceIadeLines.bind(this);
		this.fetchUserDefinitionValues  = this.fetchUserDefinitionValues.bind(this);
		this.checkConnectorPayment = this.checkConnectorPayment.bind(this);
		this.setAdditionalInformation = this.setAdditionalInformation.bind(this);
	}

	static calculateTotal(tData, isFree) {
		let data = deepCopyObject(tData);
		let trdDocInvoiceLines = data.trdDocInvoiceLines;
		let lineExtensionTotalAmount = new Decimal(0.00);
		let lineChargeTotalAmount = new Decimal(0.00);
		let allowanceTotalAmount = new Decimal(0.00);
		let toBeAddedTotalChargeAmount = new Decimal(0.00);
		for (let i = 0; i < trdDocInvoiceLines.length; i++) {
			let trdDocInvoiceLine = trdDocInvoiceLines[i];
			if(trdDocInvoiceLine.quantity !== 0) {
				let trdDocInvoiceLineCharges = trdDocInvoiceLine.trdDocInvoiceLineCharges;
				lineExtensionTotalAmount = lineExtensionTotalAmount.add(new Decimal(new Decimal(trdDocInvoiceLine.quantity).mul(new Decimal(trdDocInvoiceLine.unitPrice)).toFixed(2)).toNumber());
				for (let j = 0; j < trdDocInvoiceLineCharges.length; j++) {
					let trdDocInvoiceLineCharge = trdDocInvoiceLineCharges[j];
					if (!(data.invoiceTypeCode === "IHRACKAYITLI" && trdDocInvoiceLineCharge.taxCode.code === "0015")) {
						if (trdDocInvoiceLineCharge.taxCode.code === "0003" || trdDocInvoiceLineCharge.taxCode.code === "0011") {
							lineChargeTotalAmount = lineChargeTotalAmount.add((new Decimal((trdDocInvoiceLineCharge.amount === "" ? 0 : (trdDocInvoiceLineCharge.amount + trdDocInvoiceLineCharge.nakitTeminatiAmount + trdDocInvoiceLineCharge.avansMahsubuAmount).toFixed(2)))).mul(trdDocInvoiceLineCharge.direction));
						} else {
							lineChargeTotalAmount = lineChargeTotalAmount.add((new Decimal(trdDocInvoiceLineCharge.amount === "" ? 0 : trdDocInvoiceLineCharge.amount.toFixed(2))).mul(trdDocInvoiceLineCharge.direction));
						}
					}

					if (trdDocInvoiceLineCharge.taxCode.code === "0000" || trdDocInvoiceLineCharge.taxCode.code === "2001" ||
						trdDocInvoiceLineCharge.taxCode.code === "2002" || trdDocInvoiceLineCharge.taxCode.code === "2003" ||
						trdDocInvoiceLineCharge.taxCode.code === "2004" || trdDocInvoiceLineCharge.taxCode.code === "2005") {
						allowanceTotalAmount = allowanceTotalAmount.add(new Decimal(trdDocInvoiceLineCharge.amount === "" ? 0 : trdDocInvoiceLineCharge.amount));
					} else if (trdDocInvoiceLineCharge.taxCode.code === "0001" || trdDocInvoiceLineCharge.taxCode.code === "3001"
						|| trdDocInvoiceLineCharge.taxCode.code === "3002") {
						allowanceTotalAmount = allowanceTotalAmount.sub(new Decimal(trdDocInvoiceLineCharge.amount === "" ? 0 : trdDocInvoiceLineCharge.amount));
					} else {
						if (trdDocInvoiceLineCharge.direction === 1) {
							if (data.invoiceTypeCode === "TEVKIFATIADE") {
								toBeAddedTotalChargeAmount = toBeAddedTotalChargeAmount.add(new Decimal(trdDocInvoiceLineCharge?.vatRefundAmount === undefined || trdDocInvoiceLineCharge?.vatRefundAmount === null || trdDocInvoiceLineCharge?.vatRefundAmount === "" ? 0 : trdDocInvoiceLineCharge.vatRefundAmount));
							} else {
								toBeAddedTotalChargeAmount = toBeAddedTotalChargeAmount.add(new Decimal(trdDocInvoiceLineCharge.amount === "" ? 0 : trdDocInvoiceLineCharge.amount.toFixed(2)));
							}
						} else {

						}
					}
				}
			}
		}
		if (isFree && data.profileId === "IHRACAT") {
			data.payableAmount = 0.00;
		} else {
			let contributionAmount = 0;
			let trdDocInvoiceNotes = data['trdDocInvoiceNotes'];

			let tTypeStr = trdDocInvoiceNotes.find(function (element) {
				return element.note.includes("SGK_TYP");
			});

			// if (data.invoiceTypeCode === "SGK" && (data.accountingCost === "SAGLIK_ECZ" || data.accountingCost === "SAGLIK_MED")) {
			if (data.invoiceTypeCode === "SGK" && data.accountingCost === "SAGLIK_ECZ") {
				let tContributionAmountStr = trdDocInvoiceNotes.find(function (element) {
					return element.note.includes("SGK_HKP");
				});
				if (tTypeStr && tTypeStr.note && tTypeStr.note.split(":")[1] === "medikal" && tContributionAmountStr) {
					contributionAmount = tContributionAmountStr.note.split(":")[1];
				}
			}
			if (contributionAmount) {
				data.allowanceTotalAmount = new Decimal(allowanceTotalAmount.add(new Decimal(contributionAmount)).toFixed(4)).toNumber();
				if (!data.isManual) {
					if (new Decimal(contributionAmount).add(data.payableAmount).toFixed(2) !== new Decimal(data.taxInclusiveAmount).toFixed(2))
						data.payableAmount = new Decimal(lineExtensionTotalAmount.add(lineChargeTotalAmount).sub(new Decimal(contributionAmount)).toFixed(2)).toNumber();
				}
			} else {
				data.allowanceTotalAmount = new Decimal(allowanceTotalAmount.toFixed(2)).toNumber();
				if (!data.isManual) {
					data.payableAmount = new Decimal(lineExtensionTotalAmount.add(lineChargeTotalAmount).toFixed(2,Decimal.ROUND_UP)).toNumber();
					if (data.profileId === "IHRACAT") {
						let totalCarriageValueAmount = 0;
						let totalInsuranceValueAmount = 0;
						for (let i = 0; i < trdDocInvoiceLines.length; i++) {
							let deliveryDetail = trdDocInvoiceLines[i]["trdDocInvoiceLineDeliveryDetail"];
							if(deliveryDetail && checkNavlun(deliveryDetail["deliveryTerms"])){
								if(deliveryDetail["declaredForCarriageValueAmount"]){
									totalCarriageValueAmount = new Decimal(totalCarriageValueAmount).add(new Decimal(deliveryDetail["declaredForCarriageValueAmount"]).toFixed(2));
								}

								if(deliveryDetail["insuranceValueAmount"]){
									totalInsuranceValueAmount = new Decimal(totalInsuranceValueAmount).add(new Decimal(deliveryDetail["insuranceValueAmount"]).toFixed(2));
								}
							}
						}
						data.payableAmount = new Decimal(lineExtensionTotalAmount.add(lineChargeTotalAmount).add(totalCarriageValueAmount).add(totalInsuranceValueAmount).toFixed(2)).toNumber();
					}
				}
			}
		}

		data.lineExtensionAmount = data.invoiceTypeCode === "TEVKIFATIADE" ?
			new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).toFixed(2)).toNumber() :
			new Decimal(lineExtensionTotalAmount.toFixed(2)).toNumber();

		if (!data.isManual) {
			let sgkType = data.trdDocInvoiceNotes.find(function (element) {
				return element.note.includes("SGK_TYP");
			});

			if (sgkType && sgkType.note && sgkType.note.split(":")[1] === "medikal") {
				data.taxInclusiveAmount = new Decimal(lineExtensionTotalAmount.add(data.allowanceTotalAmount).add(toBeAddedTotalChargeAmount).toFixed(2)).toNumber();
			} else if (sgkType && sgkType.note && sgkType.note.split(":")[1] === "cezaeviEczanem") {
				data.taxInclusiveAmount = new Decimal(lineExtensionTotalAmount.add(toBeAddedTotalChargeAmount).toFixed(2)).toNumber();
				data.payableAmount = data.taxInclusiveAmount;
			} else {
				data.taxInclusiveAmount = new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).add(toBeAddedTotalChargeAmount).toFixed(2)).toNumber();
			}
		}
		if (!data.isManual)
			data.taxExclusiveAmount = new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).toFixed(2)).toNumber();

		for (let i = 0; i < data.trdDocInvoiceLines.length; i++) {
			data.trdDocInvoiceLines[i].totalPrice = new Decimal((data.trdDocInvoiceLines[i].unitPrice * data.trdDocInvoiceLines[i].quantity).toFixed(2)).toNumber();
			for (let j = 0; j < data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges.length; j++){
				if(data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges[j].taxCode.code === "0003" || data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges[j].taxCode.code === "0011"){
					data.trdDocInvoiceLines[i].totalPrice = new Decimal((data.trdDocInvoiceLines[i].totalPrice +
						((data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges[j].amount + data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges[j].nakitTeminatiAmount + data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges[j].avansMahsubuAmount) * data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges[j].direction)).toFixed(2)).toNumber();
				}else{
					data.trdDocInvoiceLines[i].totalPrice = new Decimal((data.trdDocInvoiceLines[i].totalPrice +
						(data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges[j].amount * data.trdDocInvoiceLines[i].trdDocInvoiceLineCharges[j].direction)).toFixed(2)).toNumber();
				}
			}
		}
		if (data.invoiceTypeCode === "TEVKIFATIADE") {
			data.payableAmount = data.taxInclusiveAmount;
		}
		return data;
	}

	setGocIdaresi(gocIdaresi, isGocIdaresi) {
		this.setExternalCustomer(gocIdaresi, gocIdaresi.externalCustomerAddressList[0]);
		let data = deepCopyObject(this.state.data);
		data["paymentFormattedName"] = gocIdaresi.formattedName;
		data["paymentVkn"] = gocIdaresi.vknTckn;
		data["paymentCity"] = gocIdaresi.externalCustomerAddressList[0].cityName;
		data["paymentCountry"] = gocIdaresi.externalCustomerAddressList[0].countryName;
		Alert.info("Ödeme Yapacak Alıcı bilgileri cari bilgilerinden kopyalanmıştır. Lütfen kontrol ediniz.", {
			position: 'top-right',
			effect: 'stackslide',
			timeout: 5000
		});
		this.setState({isGocIdaresi, data});
	}

	setMedulaOptik(extCust, extCustAdd) {
		this.setExternalCustomer(extCust, extCustAdd);
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		this.checkLocationChange(prevProps);
	}

	checkLocationChange(prev){
		let self = this;
		const locationChanged = self.props.location !== prev.location;
		let data = self.state.data;
		if(locationChanged){
			this.initialization();
		}
	}

	switchManualInput(e) {
		let self=this;
		let data = deepCopyObject(self.state.data)
		data["sgkPeriodManualInput"] = e.target.checked
		if(!e.target.checked){
			data["periodStartDate"] = null
			data["periodEndDate"] = null
		}
		self.setState({manualInput: e.target.checked, data});
	}

	initialization(){
		this.checkUserRights();
		let self = this;
		let match = this.props.match;
		let params = {
			url: `/invoice${match.params.direction}/edit/${match.params.recordId}`,
			method: "post",
			data: {
				profileId: (match.params.direction === "Tmp" && match.params.type === "EARSIVFATURA") ? "EARSIVFATURA" : "",
			}
		};
		request(params)
			.then(response => {
				let data = response.data.trdDocInvoice;
				if (!data.externalCustomer) {
					data.externalCustomer = {
						commerceChamber: null,
						customer: null,
						externalCustomerAddressList: [],
						familyName: null,
						formattedName: null,
						givenName: null,
						mersisNumber: null,
						middleName: null,
						recordId: null,
						taxOffice: null,
						title: null,
						tradeRegistrationNumber: null,
						vknTckn: null,
						isForeignCustomer: false,
					};
				}

				let approveAsDespatch = false;

				if (data.trdDocInvoiceNotes.length >= 1) {
					let notes = data.trdDocInvoiceNotes;
					let found = false;
					for (let i = 0; i < notes.length; i++) {
						if (notes[i].note.includes("İrsaliye yerine geçer.")) {
							found = true;
							approveAsDespatch = true;
							break;
						}
					}
				}
				let checkAddress = data.externalCustomer.externalCustomerAddressList.filter((f) => f.defaultAddress === true);
				if (checkAddress !== undefined && checkAddress !== null && checkAddress.length > 0){
					data.externalCustomerAddress = checkAddress[0];
				}
				if (!data.externalCustomerAddress) {
					data.externalCustomerAddress = {
						buildingName: null,
						buildingNo: null,
						cityName: null,
						citySubdivisionName: null,
						countryName: null,
						email: null,
						fax: null,
						postalAddressRegion: null,
						postalAddressRoom: null,
						postalZone: null,
						postboxAlias: null,
						recordId: null,
						streetName: null,
						telephone: null,
						webSite: null
					};
				}

				if (this.props.location.state && this.props.location.state.type) {
					let {externalCustomer, externalCustomerAddress, invoiceTypeInfo} = this.props.location.state.type;
					data.profileId = invoiceTypeInfo.profileId;
					data.invoiceTypeCode = invoiceTypeInfo.invoiceTypeCode;
					data.accountingCost = invoiceTypeInfo.accountingCost;
					if (invoiceTypeInfo.retailCustomer) {
						data.retailCustomer = invoiceTypeInfo.retailCustomer;
					}
					if (externalCustomer && externalCustomerAddress) {
						data.externalCustomer = externalCustomer;
						data.externalCustomerAddress = externalCustomerAddress;
					}
					if (!!invoiceTypeInfo.invoiceLines) {
						data.trdDocInvoiceLines = invoiceTypeInfo.invoiceLines;
					}
					data = this.predefinedInvoiceType(data, invoiceTypeInfo);
				}

				if(match.params.type === "partialRefund"){
					Alert.warning("Lütfen kısmi iade faturanızı kontrol edip kaydediniz!", {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				}

				if (data.externalCustomer.externalCustomerMainType === "FOREIGN") {
					data.isForeignCustomer = true;
				}

				if(match.params.recordId <= 0 && (!this.props.location.state || (this.props.location.state && this.props.location.state.type && this.props.location.state.type.value === undefined))){
					let userDefinition = this.state.userDefinition;
					if(userDefinition != null){
						data.profileId = userDefinition.documentProfile ? userDefinition.documentProfile : data.profileId;
						if (data.profileId === "YOLCUBERABERFATURA" || data.profileId === "IHRACAT") {
							data.invoiceTypeCode = "ISTISNA";
						}

					}
				}


				self.setState({
					data: data,
					iade: data.invoiceTypeCode === "IADE",
					initData: deepCopyObject(data),
					userAliasList: response.data.userAliasList,
					xslts: response.data.xslts,
					charges: response.data.charges,
					unitCodes: response.data.unitCodes,
					currencyCodes: response.data.currencyCodes,
					profileIds: response.data.profileIds,
					invoiceTypeCodes: response.data.invoiceTypeCodes,
					additionalDocuments: response.data.trdDocInvoice.trdDocInvoiceAdditionalDocuments,
					exemptions: response.data.exemptions,
					countries: response.data.countries,
					classificationTypes: response.data.classificationTypes,
					packageTypeCodes: response.data.packageTypeCodes,
					deliveryTermsCodes: response.data.deliveryTermsCodes,
					transportMeansTypeCodes: response.data.transportMeansTypeCodes,
					transportModeCodes: response.data.transportModeCodes,
					saleTypes: response.data.saleTypes,
					accountingCosts: response.data.accountingCosts,
					paymentMeansCodes: response.data.paymentMeansCodes,
					paymentChannelCodes: response.data.paymentChannelCodes,
					cities: response.data.cities,
					withholdingTypes: response.data.withholdingTypes,
					manualInput: data.sgkPeriodManualInput,
					approveAsDespatch,
					suffix: (response.data.currencyCodes).find(x => x.shortCode === response.data.trdDocInvoice.documentCurrencyCode).symbol,
				});
				this.setShowOrderManagerLineNum(data.externalCustomer.vknTckn);

				if (this.props.location.state && this.props.location.state.hedefIadeInvoice) {
					let data = CreateEditInvoice.calculateTotal(this.props.location.state.hedefIadeInvoice, this.state.isFree);
					this.setState({data, manual: true});
				}

				this.fetchPredefinedInvoiceForUser();
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	componentDidMount() {
		this.initialization();
		let isCreditSufficient = this.props.isCreditSufficient!=undefined ? this.props.isCreditSufficient:true;
		this.setState({isCreditSufficient});
		if(hasUserRight(UserRightsEnum.ekonnektor.view,this.props.currentUser)){
			this.getConnectionInfo();
		}
	}

	componentWillMount() {
		this.fetchUserDefinitionValues();
	}

	fetchUserDefinitionValues = () => {
		let self = this;
		let profileId= self.props.match.params.type;
		let params = {
			url: `/customer/getUserDefinition?docType=${profileId}`,
			method: "get"
		};
		request(params)
			.then(function (response) {
				self.setState({userDefinition: response.data})
			}).catch(function (error) {
			showAxiosError(error);
		});
	}


	getConnectionInfo = async()=>{
		let self = this;
		let params = {
			url: `/connector/getConnectionInfo`,
			method: "post"
		};
		try{
			let {data} = await request(params);
			if(data!=null){
				self.setState({connectionInfo:data});
			}
		}catch(error){
			//let err = {response:{data:"Konnektör Bulunamadı"}}
			//showAxiosError(err);
		}
	}

	checkUserRights() {
		if ( (this.props.match.params.recordId === "0" && !hasUserRight([UserRightsEnum.earchive.create, UserRightsEnum.invoice.create], this.props.currentUser))
			|| (this.props.match.params.recordId !== "0" && !hasUserRight([UserRightsEnum.earchive.update, UserRightsEnum.invoice.update], this.props.currentUser)) ){
			this.props.history.push("/");
		}
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({activeTab: tab});
		}
	}

	calculateCost(amount) {
		let data = deepCopyObject(this.state.data);
		let costs = data['tmpDocInvoiceBrokerCosts'];
		let totalName = "";
		let totalNumber = 0;
		for (let [key, value] of Object.entries(costs)) {
			totalName = "";
			totalNumber = 0;
			if (key.toString().includes('Percentage')) {
				totalName = key.toString().substring(0, key.toString().indexOf('Percentage')) + 'Total';
				totalNumber = new Decimal(amount).toNumber() * new Decimal(value).toNumber() / new Decimal(100).toNumber();
				costs[totalName] = totalNumber;
			}
		}
		return costs;
	}

	costsListener(costs) {
		let data = deepCopyObject(this.state.data);
		data['tmpDocInvoiceBrokerCosts'] = costs;
		let totalCosts = this.calculateTotalCosts(costs);
		if ((data.profileId === "HKS" && data.invoiceTypeCode === "KOMISYONCU") || data.invoiceTypeCode === "HKSKOMISYONCU") {
			data['payableAmount'] = new Decimal(data['taxInclusiveAmount']).toNumber() - new Decimal(totalCosts).toNumber();
		} else {
			let sgkType = data.trdDocInvoiceNotes.find(function (element) {
				return element.note.includes("SGK_TYP");
			});

			if (sgkType && sgkType.note && sgkType.note.split(":")[1] === "medikal")
				data['payableAmount'] = new Decimal(new Decimal(data["taxInclusiveAmount"]).sub(data.allowanceTotalAmount).toFixed(2)).toNumber();
			else{
				//data['payableAmount'] = new Decimal(data['taxInclusiveAmount']).toNumber();
				data = CreateEditInvoice.calculateTotal(data, this.state.isFree);
			}
		}
		this.setState({data});
	}

	calculateTotalCosts(costs) {
		let totalCosts = new Decimal(0).toNumber();
		let value;
		for (value in costs) {
			if (value.toString().includes("Total")) {
				totalCosts += new Decimal(costs[value]).toNumber();
			}
		}
		this.setState({totalCosts});
		return totalCosts;
	}

	setAdditionalDocument(additionalDocument) {
		let data = deepCopyObject(this.state.data);
		let additionalDocuments = additionalDocument
		data['trdDocInvoiceAdditionalDocuments'] = additionalDocument;
		this.setState({data,additionalDocuments});
	}

	setLoadingBank(loadingBankData){
		let loadingBank = loadingBankData;
		this.setState({loadingBank})
	}

	invoiceTypeListener(invoiceTypeInfo) {

		let data = deepCopyObject(this.state.data);
		let oldInvoiceTypeCode = deepCopyObject(data.invoiceTypeCode);
		data = whenInvoiceTypeChange(data, invoiceTypeInfo);
		if ((oldInvoiceTypeCode !== "IHRACKAYITLI" && invoiceTypeInfo.invoiceTypeCode === "IHRACKAYITLI") ||
				(oldInvoiceTypeCode === "IHRACKAYITLI" && invoiceTypeInfo.invoiceTypeCode !== "IHRACKAYITLI")) {
			data = CreateEditInvoice.calculateTotal(data, this.state.isFree);
		}
		let iade = invoiceTypeInfo.invoiceTypeCode === "IADE";
		if(!checkIade(invoiceTypeInfo.invoiceTypeCode)){
			data.trdDocInvoiceIadeLines=[];
		}

		if(data.profileId !== "EARSIVFATURA"){
			data.retailCustomer = false;
		}
		if (invoiceTypeInfo.invoiceTypeCode === 'KONAKLAMAVERGISI') {

			data.trdDocInvoiceLines.map((line) =>
				line.trdDocInvoiceLineCharges = [{
				    recordId: null,
					amount: (line.unitPrice / 100) * 2,
					calculatedBy: "AMOUNT",
					direction: 1,
					exemptionReasonCode: null,
					exemptionReason: null,
					taxableAmount: line.unitPrice * line.quantity,
					percentage: 2,
					perUnitAmount: 0.0,
					taxCode: this.state.charges.find(function (charge) {
						return charge.code === '0059';
					}),
					invoiceLineId: null,
					withholdingCode: null
				},		{
					recordId: null,
					amount: 0,
					calculatedBy: "AMOUNT",
					direction: -1,
					exemptionReasonCode: null,
					taxableAmount: 1.0,
					percentage: 0.0,
					perUnitAmount: 0.0,
					taxCode: this.state.charges.find(function (charge) {
						return charge.code === '0000';
					}),
					invoiceLineId: null,
					withholdingCode: null
				},{
					recordId: null,
					amount: 0,
					calculatedBy: "AMOUNT",
					direction: -1,
					exemptionReasonCode: null,
					exemptionReason: null,
					taxableAmount: 1.0,
					percentage: 0.0,
					perUnitAmount: 0.0,
					taxCode: this.state.charges.find(function (charge) {
						return charge.code === '0015';
					}),
					invoiceLineId: null,
					withholdingCode: null
				}]

			)
		}
		this.setState({data, iade}, () => this.invoiceTypeListenerCallbacks(data['tmpDocInvoiceBrokerCosts']));
	}

	invoiceTypeListenerCallbacks(costs) {
		this.costsListener(costs);
		this.renderGekAlert();
	}

	predefinedInvoiceType = (data, invoiceTypeInfo) => {
		let oldInvoiceTypeCode = data.invoiceTypeCode;
		data = whenInvoiceTypeChange(data, invoiceTypeInfo);

		if ((oldInvoiceTypeCode !== "IHRACKAYITLI" && invoiceTypeInfo.invoiceTypeCode === "IHRACKAYITLI") ||
				(oldInvoiceTypeCode === "IHRACKAYITLI" && invoiceTypeInfo.invoiceTypeCode !== "IHRACKAYITLI")) {
			data = CreateEditInvoice.calculateTotal(data, this.state.isFree);
		}
		return data;
	};

	setTrdDocInvoiceNotes(trdDocInvoiceNotes) {
		let data = deepCopyObject(this.state.data);
		data['trdDocInvoiceNotes'] = trdDocInvoiceNotes;
		this.setState({data});
	}

	setTrdDocInvoiceDespatchReferences(trdDocInvoiceDespatchReferences) {
		let data = deepCopyObject(this.state.data);
		data['trdDocInvoiceDespatchReferences'] = trdDocInvoiceDespatchReferences;
		this.setState({data});
	}

	setTrdDocInvoiceInternetSales(internetSales) {
		let data = deepCopyObject(this.state.data);
		data["trdDocInvoiceInternetSales"] = internetSales;
		if (!internetSales) {
			data["carrierPartyId"] = null;
			data["carrierPartyName"] = null;
			data["actualDeliveryDate"] = null;
			data["carrierPartyFirstName"] = null;
			data["carrierPartyFamilyName"] = null;
		}
		this.setState({data});
	}

	setTrdDocInvoiceCarrierParty(carrierParty) {
		let data = deepCopyObject(this.state.data);
		data["carrierPartyId"] = carrierParty.carrierPartyId;
		data["carrierPartyName"] = carrierParty.carrierPartyName;
		data["actualDeliveryDate"] = carrierParty.actualDeliveryDate;
		data["carrierPartyFirstName"] = carrierParty.carrierPartyFirstName;
		data["carrierPartyFamilyName"] = carrierParty.carrierPartyFamilyName;
		this.setState({data});
	}

	setTouristInfo(touristInfo) {
		if (touristInfo) {
			let data = deepCopyObject(this.state.data);
			if (!data["trdDocInvoiceTaxFree"])
				data["trdDocInvoiceTaxFree"] = {};

			data["trdDocInvoiceTaxFree"]["firstName"] = (touristInfo.hasOwnProperty("firstName") ? touristInfo["firstName"] : null);
			data["trdDocInvoiceTaxFree"]["familyName"] = (touristInfo.hasOwnProperty("familyName") ? touristInfo["familyName"] : null);
			data["trdDocInvoiceTaxFree"]["touristCity"] = (touristInfo.hasOwnProperty("touristCity") ? touristInfo["touristCity"] : null);
			data["trdDocInvoiceTaxFree"]["touristCitySubdivision"] = (touristInfo.hasOwnProperty("touristCitySubdivision") ? touristInfo["touristCitySubdivision"] : null);
			data["trdDocInvoiceTaxFree"]["touristCountry"] = (touristInfo.hasOwnProperty("touristCountry") ? touristInfo["touristCountry"] : null);
			data["trdDocInvoiceTaxFree"]["touristNationality"] = (touristInfo.hasOwnProperty("touristNationality") ? touristInfo["touristNationality"] : null);
			data["trdDocInvoiceTaxFree"]["touristPassportDate"] = (touristInfo.hasOwnProperty("touristPassportDate") ? touristInfo["touristPassportDate"] : null);
			data["trdDocInvoiceTaxFree"]["touristPassportNo"] = (touristInfo.hasOwnProperty("touristPassportNo") ? touristInfo["touristPassportNo"] : null);
			this.setState({data});
		}
	}

	setTrdDocInvoiceTaxRepresentativeParty(taxRepresentativeParty) {
		let data = deepCopyObject(this.state.data);
		if (!data["trdDocInvoiceTaxFree"])
			data["trdDocInvoiceTaxFree"] = {};

		data["trdDocInvoiceTaxFree"]["trpAlias"] = (taxRepresentativeParty.hasOwnProperty("trpAlias") ? taxRepresentativeParty["trpAlias"] : null);
		data["trdDocInvoiceTaxFree"]["trpCity"] = (taxRepresentativeParty.hasOwnProperty("trpCity") ? taxRepresentativeParty["trpCity"] : null);
		data["trdDocInvoiceTaxFree"]["trpCitySubdivision"] = (taxRepresentativeParty.hasOwnProperty("trpCitySubdivision") ? taxRepresentativeParty["trpCitySubdivision"] : null);
		data["trdDocInvoiceTaxFree"]["trpCountry"] = (taxRepresentativeParty.hasOwnProperty("trpCountry") ? taxRepresentativeParty["trpCountry"] : "Türkiye");
		data["trdDocInvoiceTaxFree"]["trpFormattedName"] = (taxRepresentativeParty.hasOwnProperty("trpFormattedName") ? taxRepresentativeParty["trpFormattedName"] : null);
		data["trdDocInvoiceTaxFree"]["trpIdentifier"] = (taxRepresentativeParty.hasOwnProperty("trpIdentifier") ? taxRepresentativeParty["trpIdentifier"] : null);
		this.setState({data});
	}

	setSGKInfo(sgkInfo) {
		let data = deepCopyObject(this.state.data);
		if (sgkInfo.sgkFileNo)
			data["sgkFileNo"] = sgkInfo.sgkFileNo;
		if (sgkInfo.sgkMukellefAdi)
			data["sgkMukellefAdi"] = sgkInfo.sgkMukellefAdi;
		if (sgkInfo.sgkMukellefKodu)
			data["sgkMukellefKodu"] = sgkInfo.sgkMukellefKodu;
		this.setState({data});
	}

    clearPaymentInfo() {
		let data = deepCopyObject(this.state.data);
        data["paymentMeansCode"] = null;
        data["paymentChannelCode"] = null;
        data["paymentFinancialAccountId"] = null;
        data["instructionNote"] = null;
        data["paymentFormattedName"] = null;
        data["paymentVkn"] = null;
        data["paymentCity"] = null;
        data["paymentCitySubdivision"] = null;
        data["paymentCountry"] = null;
        this.setState({data});
    }

    setPaymentInfo(paymentInfo) {
        let data = deepCopyObject(this.state.data);
        data["paymentMeansCode"] = paymentInfo.paymentMeansCode;
        data["paymentChannelCode"] = paymentInfo.paymentChannelCode;
        data["paymentFinancialAccountId"] = paymentInfo.paymentFinancialAccountId;
        data["instructionNote"] = paymentInfo.instructionNote;
        data["paymentFormattedName"] = paymentInfo.paymentFormattedName;
        data["paymentVkn"] = paymentInfo.paymentVkn;
        data["paymentCity"] = paymentInfo.paymentCity;
        data["paymentCountry"] = paymentInfo.paymentCountry;
        this.setState({data});
    }

    setOrderReference(orderReference) {
        let data = deepCopyObject(this.state.data);
        data['orderReferenceNumber'] = orderReference.orderReferenceNumber;
        data['orderReferenceDate'] = orderReference.orderReferenceDate;
        data['receiptDocumentReferenceNo'] = orderReference.receiptDocumentReferenceNo;
        data['orderManager'] = orderReference.orderManager;
        this.setState({data});
    }

	setAdditionalInformation(item){
		let data = deepCopyObject(this.state.data);
		data['imei'] = item.imei;
		data['mac'] = item.mac;
		data['aracKimlikNo'] = item.aracKimlikNo;
		data['plakaNo'] = item.plakaNo;
		data['esuRaporId'] = item.esuRaporId;
		data['esuRaporIdIssueDate'] = item.esuRaporIdIssueDate;
		data['paymentDueDate'] = item.paymentDueDate;
		this.setState({data});
	}

	onClickSave(e, type) {
        let self = this;
        e.preventDefault();
        this.setState({saveLoading: true, saveType: type});
        let data = deepCopyObject(self.state.data);

        if (type === "new") {
            let one = deepCopyObject(data);
            let compareTo = deepCopyObject(self.state.initData);
            if (!compareTo.sourceUrn) {
                one.sourceUrn = null;
            }
            if (!(_.isEqual(one, compareTo))) {
                Swal({
                    title: 'Onay',
                    text: 'Faturadaki değişiklikler kaydedilsin mi?',
                    showCancelButton: true,
                    confirmButtonText: 'Evet',
                    cancelButtonText: 'Hayır',
                    showCloseButton: true,
                    onClose: () => {
                        self.setState({saveLoading: false});
                    }
                }).then((result) => {
                    if (result.value) {
                        self.saveDocument(data, type);
                        Swal.close();
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.close();
                        self.getInitInvoice("Yeni oluşturuldu.");
                    }
                });
            } else {
                this.getInitInvoice("Yeni oluşturuldu.");
            }
        } else if (type === "look") {
            this.showDocument();
        } else if (type === "save") {
            this.saveDocument(data, type);
        } else if (type === "saveClose") {
            this.saveDocument(data, type);
        } else if (type === "directSend") {
            this.saveDocument(data, type);
        } else if (type === "saveSend") {
            //Hatalı faturanın düzenlenmiş halini gönderiyoruz. keşke sendCorrectedInvoice yazaydın tatlım
            if (this.state.data.deletedAt)
                this.sendIncorrectInvoice();
            else
                this.setState({saveLoading: false});
        } else {
            this.setState({saveLoading: false});
        }
    }

    sendIncorrectInvoice() {
        let self = this;
        let item = self.state.data;
        let match = self.props.match;
        let result = isValidInvoice(item, match.params.direction, this.isKamu(), this.state.activeTab, this.state.innerActiveTab, this.state.isGocIdaresi,this.props.currentUser);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            let params = {
                url: `/invoice${match.params.direction}/update`,
                method: 'post',
                data: item
            };

            self.setState({saveLoading: true});
            request(params)
                .then(function (response) {
					if (self.state.data.profileId === "EARSIVFATURA") {
						cacheInstance.delete("archive");
						self.props.history.push(`/eAInvoice`);
					}
                    else {
						cacheInstance.delete("outbox");
						self.props.history.push(`/eInvoiceOutbox`);
					}

                    Alert.closeAll();
                    Alert.success("Düzenlenmiş fatura başarılı şekilde gönderildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                    self.setState({saveLoading: false});
                }).catch(function (error) {
                self.setState({saveLoading: false});
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({error: error, saveLoading: false});
        }
    }

    preventNull(data) {
        let lines = deepCopyObject(data.trdDocInvoiceLines);
        for (let i = 0; i < lines.length; i++) {
            let lineCharges = deepCopyObject(lines[i].trdDocInvoiceLineCharges);
            for (let j = 0; j < lineCharges.length; j++) {
                if (lineCharges[j].percentage === null || lineCharges[j].percentage === undefined) {
                    lineCharges[j].percentage = new Decimal(0).toNumber();
                }
            }
        }
        data["trdDocInvoiceLines"] = lines;
        return data;
    }

	saveDocument(data, type) {
		let result = isValidInvoice(data, this.props.match.params.direction, this.isKamu(), this.state.activeTab, this.state.innerActiveTab, this.state.isGocIdaresi, this.props.currentUser);
		data = this.preventNull(data);
		let error = result.error;
		let valid = result.valid;
		let self = this;
		let match = self.props.match;
		if (valid) {
			if (!data["from"]) {
				data["from"] = DocumentFrom.PORTAL;
			}

			const konaklamaData = data.trdDocInvoiceLines.map((line) =>
				line.trdDocInvoiceLineCharges.filter((charge) =>
					charge.taxCode.code === '0059'
				));

			if (konaklamaData && konaklamaData[0] && konaklamaData[0][0] && konaklamaData[0][0].percentage === 0 && data.invoiceTypeCode !== 'ISTISNA'){
				this.setState({saveLoading: false});
				return 	Alert.error('Fatura Tipini İstisna Yapınız.', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
			}

			if (data.invoiceTypeCode === 'TEKNOLOJIDESTEK') {
				if (data.externalCustomer.vknTckn === "11111111110") {
					return 	Alert.error('Teknoloji Destek Fatura Tipinde Tüketici TC Kimlik Numarası Nihai Tüketici olamaz.', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 2000
					});
				}
			}

			const invoiceIadeLine = data.trdDocInvoiceIadeLines;
			if (data.profileId === 'ILAC_TIBBICIHAZ' || data.invoiceTypeCode === 'TEKNOLOJIDESTEK') {
				for (let i = 0; i < data.trdDocInvoiceLines.length; i++) {
					if (data.trdDocInvoiceLines[i].trdDocInvoiceLineProductModelCodes === undefined ||
						data.trdDocInvoiceLines[i].trdDocInvoiceLineProductModelCodes === null ||
						data.trdDocInvoiceLines[i].trdDocInvoiceLineProductModelCodes?.length === 0 ||
						data.trdDocInvoiceLines[i].quantity !== data.trdDocInvoiceLines[i].trdDocInvoiceLineProductModelCodes?.length) {
						this.setState({saveLoading: false});
						return Alert.error("Ürün tipi ve karekodunu doldurunuz.", {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000
						});
					}
				}
			}

			if (checkIade(data.invoiceTypeCode) && invoiceIadeLine === null) {
				this.setState({saveLoading: false});
				return Alert.error("Fatura Numarası Alanı Boş Olamaz!.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			} else if (checkIade(data.invoiceTypeCode) && invoiceIadeLine.length > 0) {
				let regex = new RegExp(/^[A-Za-z0-9]{3}(19|20)\d{11}/)
				for (let i = 0; i < invoiceIadeLine.length; i++) {
					if (invoiceIadeLine[i].invoiceNumber === null) {
						this.setState({saveLoading: false});
						return Alert.error("Fatura Numarası Alanı Boş Olamaz!.", {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000
						});
					}
					if (!invoiceIadeLine[i].invoiceNumber.match(regex)) {
						this.setState({saveLoading: false});
						return Alert.error("Fatura Numarası Yanlış Girilmiştir.", {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000
						});
					}
				}
			}

			let params = {
				url: `/invoice${this.props.match.params.direction}/save`,
				method: "post",
				data: data
			};
			self.setState({saveLoading: true});
			request(params)
					.then(response => {

						let data = response.data;
						self.setState({saveLoading: false, data: data, initData: deepCopyObject(data)});
						if (type === "saveClose") {
							if (self.state.data.profileId === "EARSIVFATURA")
								self.props.history.push(`/archiveInvoice${match.params.direction}`);
							else
								self.props.history.push(`/invoice${match.params.direction}`);
						} else if (type === "new") {
							self.getInitInvoice("Kaydedildi");
						} else if (type === "directSend") {
							if(data.documentId && (['GOC','SGK'].includes(data.documentId.substring(0,3)) || (showConnector(EntegratorConf.identifier)  && hasUserRight(UserRightsEnum.ekonnektor.send,this.props.currentUser)))){
								self.setState({ documentId : data.documentId, item: data}, () => {
									self.confirmSend(data);
								});
							} else {
								self.handleSend(data);
						    }
						}
						if (type !== "new") {
							Alert.closeAll();
							Alert.success('Kaydedildi', {
								position: 'top-right',
								effect: 'stackslide',
								timeout: 2000
							});
						}
					})
					.catch(function (error) {
						self.setState({saveLoading: false});
						showAxiosError(error);
					});
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 8000
			});
			self.setState({
				error: error,
				saveLoading: false,
				activeTab: result.activeTab,
				innerActiveTab: result.innerActiveTab
			});
		}
	}

	handleWebsocket = () =>{
		const {connectionInfo} = this.state;
		let ip = connectionInfo.ownerIp + "/websocket/chat";
		const ws = new WebSocket(ip);
		this.setState({ws});
		ws.onopen = () => {
			console.log("connected")
		}

		ws.onmessage = evt => {
			let {queryType,rows,uuid} = JSON.parse(evt.data)
			rows = JSON.parse(rows);
			if(queryType == "ERROR" && rows && rows[0].error){
				console.log(rows[0].error);
				this.setState({searching:false})
			}else if((queryType === "UPDATE_INVOICE_NUMBER") && rows != null){
				let documentId = rows[0].documentId;
				if(documentId!=null ){
					let params = {
						url: `/connector/updateSqlHistory/invoice/${documentId}`,
						method: "post"
					};
					let {data} = request(params);
				}
			}
		}
		ws.onclose = () => {
			console.log("connected")
		}
	}

	updateInvoiceNumberWs = async (recordId) =>{
		let self = this;
		const {connectionInfo} = self.state;
		if(connectionInfo!=null && connectionInfo.connectionType === "WEBSOCKET"){
			self.handleWebsocket();
			let params = {
				url: `/connector/getUpdateSql/${recordId}/invoice`,
				method: "post"
			};
			try{
				let {data} = await request(params);
				if(data) {
					self.sendWebsocketMessage(data, "UPDATE_INVOICE_NUMBER")
				}
			}catch(error){
				let err = {response:{data:error.toString()}}
				showAxiosError(err);
			}
		}
	}
	sendWebsocketMessage = async (query,queryType,documentUuid) =>{
		let ws = this.state.ws;
		if(ws.readyState !== 1){
			await new Promise(r => setTimeout(r, 1000));
		}
		if ( ws.readyState === 3 ) {
			ws.close();
			this.handleWebsocket();

			// wait until new connection is open
			while (ws.readyState !== 1) {
				await new Promise(r => setTimeout(r, 1000));
			}
		}
		const {connectionInfo} = this.state;
		const {currentUser} = this.props;

		let header = {
			customerId: currentUser.customerId,
			dataSource: connectionInfo.dataSource,
			initialCatalog: connectionInfo.initialCatalog,
			dbUser: connectionInfo.dbUser,
			dbPassword: connectionInfo.dbPassword,
			key: connectionInfo.key,
			branchId: connectionInfo.branchId,
			clientType:"PORTAL"
		}
		let body = {
			uuid:documentUuid?documentUuid: uuidGenerator(),
			queryType: queryType,
			query: query
		};

		let jsonMsg = JSON.stringify({header,body})
		ws.send(jsonMsg);
	}

	getInitInvoice(info) {
		let self = this;
		let match = self.props.match;
		let params = {
			url: `/invoice${match.params.direction}/edit/-1`,
			method: "post",
			data: {
				profileId: (match.params.direction === "Tmp" && match.params.type === "EARSIVFATURA") ? "EARSIVFATURA" : "",
			}
		};
		request(params)
				.then(response => {
					Alert.closeAll();
					Alert.success(info, {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 2000
					});
					let data = response.data.trdDocInvoice;
					self.setState({data: data, initData: deepCopyObject(data), saveLoading: false, manual: true});
				})
				.catch(function (error) {
					self.setState({saveLoading: false});
					showAxiosError(error);
				});
	}

	isManual(manual) {
		this.setState({manual});
	}

	updateScenario(isUpdateScenario) {
		this.setState({isUpdateScenario});
	}

	isKamu() {
		const {data} = this.state;
		const {externalCustomerAddress, profileId} = data;

		if (!!externalCustomerAddress) {
			if (profileId === 'KAMU' ||
				("urn:mail:defaultpk@muhasebat.gov.tr" === externalCustomerAddress.postboxAlias &&
					(!!profileId && (profileId === 'TEMELFATURA' || profileId === 'TICARIFATURA')))) {
				return true;
			}
		}
		return false;
	}

	getPeriods() {
		let data = deepCopyObject(this.state.data);
        return this.state.periods &&  this.state.periods.length>0 ? this.state.periods : this.updatePeriodList(data);
	}

	onChangePeriod(e) {
		let data = deepCopyObject(this.state.data);
		if (this.state.manualInput) {
			data["periodStartDate"] = e.split(".")[0];
			data["periodEndDate"] = e.split(".")[1];
		} else {
			let {value} = e;
			data["periodStartDate"] = value.split(".")[0];
			data["periodEndDate"] = value.split(".")[1];
			data["sgkPeriodManualInput"] = false;
		}
		this.setState({data});
	}

	onChangeDate(momentObj, name, fullFieldName) {
		let data = deepCopyObject(this.state.data);
		if (!(typeof momentObj === "string")) {
			if (name === "date") {
				let date = momentObj.format("YYYY-MM-DD");
				let time = moment(data.issueDate).format("HH:mm:ss");
				data.issueDate = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
                this.setState({data},()=>this.updatePeriodList(data));
			} else if (name === "time") {
				let time = momentObj.format("HH:mm:ss");
				let date = moment(data.issueDate).format("YYYY-MM-DD");
				data.issueDate = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
                this.setState({data},()=>this.updatePeriodList(data));
			} else if (name === "manualPeriodDate") {
				let lastDay = momentObj.daysInMonth()
				let manualPeriodDate = momentObj.format("YYYY-MM-DD." + "YYYY-MM-" + lastDay)
				this.onChangePeriod(manualPeriodDate);
			} else if (name === "datetime") {
				data[fullFieldName] = momentObj.format("YYYY-MM-DDTHH:mm:ss");
				this.setState({data})
			}
			else {
			}
		} else {
		}
	}

	updatePeriodList(data){
        if(data.invoiceTypeCode === "SGK"){
			let startOfMonth = moment(data.issueDate).startOf('month').format("YYYY-MM-DD");
			let middleOf15Month = moment(data.issueDate).format("YYYY-MM-15");
			let middleOf16Month = moment(data.issueDate).format("YYYY-MM-16");
			let endOfMonth = moment(data.issueDate).endOf('month').format("YYYY-MM-DD");

			let startOfPreviousMonth = moment(data.issueDate).subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
			let middleOf15PreviousMonth = moment(data.issueDate).subtract(1, 'months').format("YYYY-MM-15");
			let middleOf16PreviousMonth = moment(data.issueDate).subtract(1, 'months').format("YYYY-MM-16");
			let endOfPreviousMonth = moment(data.issueDate).subtract(1, 'months').endOf('month').format("YYYY-MM-DD");

			let periods = [
				{
                    label:"(" +moment(startOfPreviousMonth).format("DD-MM-YYYY") + ")-(" + moment(middleOf15PreviousMonth).format("DD-MM-YYYY") + ")",
                    value:startOfPreviousMonth + "." + middleOf15PreviousMonth
				},
				{
                    label:"(" +moment(middleOf16PreviousMonth).format("DD-MM-YYYY") + ")-(" + moment(endOfPreviousMonth).format("DD-MM-YYYY") + ")",
                    value:middleOf16PreviousMonth + "." + endOfPreviousMonth
				},
				{
                    label:"(" +moment(startOfPreviousMonth).format("DD-MM-YYYY") + ")-(" + moment(endOfPreviousMonth).format("DD-MM-YYYY") + ")",
                    value:startOfPreviousMonth + "." + endOfPreviousMonth
				},
				{
                    label:"(" +moment(startOfMonth).format("DD-MM-YYYY") + ")-(" + moment(middleOf15Month).format("DD-MM-YYYY") + ")",
                    value:startOfMonth + "." + middleOf15Month
				},
				{
                    label:"(" +moment(middleOf16Month).format("DD-MM-YYYY") + ")-(" + moment(endOfMonth).format("DD-MM-YYYY") + ")",
                    value:middleOf16Month + "." + endOfMonth
				},
				{
                    label:"(" +moment(startOfMonth).format("DD-MM-YYYY") + ")-(" + moment(endOfMonth).format("DD-MM-YYYY") + ")",
                    value:startOfMonth + "." + endOfMonth
				}
			];

            let day =moment(data.issueDate).format('D');
            let result = (data.trdDocInvoiceLines[0].itemName && data.trdDocInvoiceLines[0].itemName.indexOf("C Grubu Kan")  !== -1);
            if(!result){
				periods.splice(0, 2);
				periods.splice(1, 2);
				let hasEkFatura = (data.trdDocInvoiceLines[0].itemName && data.trdDocInvoiceLines[0].itemName.indexOf("Ek Fatura Reçete Bedeli")  !== -1);
                if((day>=1 && day<=15) && !hasEkFatura){
                    data["periodStartDate"]=startOfPreviousMonth;
                    data["periodEndDate"]=endOfPreviousMonth;
                }else{
                    data["periodStartDate"]=startOfMonth;
                    data["periodEndDate"]=endOfMonth;
				}
			}
            this.setState({periods,data});
        }else{
            data["periodStartDate"]=null;
            data["periodEndDate"]=null;
            this.setState({periods:[],data});
		}
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		const fieldValue = e.target.value;
		let result = validateField(rule, boundary, fieldValue);

		if (id === "oppositeDocNo") {
			const regex = /^\d{4}\/\d{2}-\d{5}$/;
			if (!regex.test(fieldValue)) {
				result = { valid: false, message: "Lütfen 3333/44-55555 formatında bir değer giriniz." };
			}
		}
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	errorListener(tError) {
		let error = this.state.error;
		error = Object.assign(error, tError);
		this.setState({error});
	}

	setExternalCustomer(externalCustomer, externalCustomerAddress) {
		this.setShowOrderManagerLineNum(externalCustomer.vknTckn);
		let data = deepCopyObject(this.state.data);
		data["externalCustomer"] = externalCustomer;
		data["externalCustomerAddress"] = externalCustomerAddress;
		this.setState({data}, () => this.setExternalCustomerCallbacks());
		if(showPredefinedBtn()){
			this.checkIfGibUser(externalCustomer);
		}

	}

	setExternalCustomerCallbacks() {
		this.setOdemeYapacakAlici();
		this.renderGekAlert();
	}

	setOdemeYapacakAlici(){
		let self = this;
		let data = deepCopyObject(this.state.data);
		if(self.isKamu()) {
			data["paymentFormattedName"] = data["externalCustomer"].formattedName;
			data["paymentVkn"]  = data["externalCustomer"].vknTckn;
			data["paymentCity"] = data["externalCustomerAddress"].cityName;
			data["paymentCountry"] = data["externalCustomerAddress"].countryName;
			Alert.info("Ödeme Yapacak Alıcı bilgileri cari bilgilerinden kopyalanmıştır. Lütfen kontrol ediniz.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
			self.setState({data},()=>self.isManual(true));
		}
	}

	async setExternalCustomerAsync(externalCustomer, externalCustomerAddress) {
		this.setShowOrderManagerLineNum(externalCustomer.vknTckn);
		let data = deepCopyObject(this.state.data);
		data["externalCustomer"] = externalCustomer;
		data["externalCustomerAddress"] = externalCustomerAddress;
		this.setState({data} , () => {this.renderGekAlert();});
		//donot check gib
	}

	setShowOrderManagerLineNum(vkn){
		this.setState({showOrderManagerLineNum: ["7350019759", "4600001884", "8720013736"].includes(vkn)})
	}

	checkIfGibUser(externalCustomer) {
		if (externalCustomer.vknTckn !== null) {
			request({url: `/externalCustomer/gib-invoice-user/${externalCustomer.vknTckn}`, type: 'get'})
					.then(response => {
						this.renderExternalCustomerPopup(externalCustomer, response.data);
					})
					.catch(error => showAxiosError(error));
		}
	}

	renderExternalCustomerPopup(externalCustomer, gibUser) {
		let self = this;
		let alert = self.renderAlertMessage(gibUser, externalCustomer);
		self.setState({alert: alert});
	};

	renderAlertMessage(gibUser, externalCustomer) {
		let self = this;
		if (gibUser && self.state.data.profileId === "EARSIVFATURA") {
			return (
					<SweetAlert showCancel warning
								confirmBtnText="Tamam"
								cancelBtnText="İptal"
								confirmBtnBsStyle="success"
								cancelBtnBsStyle="default"
								title="Onay"
								onConfirm={() => {
									let pre = {
										invoiceTypeInfo: {
											invoiceTypeCode: "SATIS",
											profileId: "TEMELFATURA",
											accountingCost: null
										},
									};
								self.setPredefinedType(pre,false);
									self.setState({alert: null});
								}}
								onCancel={() => self.setState({alert: null})}>
						{externalCustomer.vknTckn} vkn/tckn numaralı {externalCustomer.formattedName} ünvanlı kullanıcı
						GİB E-Fatura listesinde kayıtlı.
						Fatura senaryo türünün E-Fatura olarak değiştirilmesini istermisiniz?
					</SweetAlert>
			);
		} else if (!gibUser && ["TEMELFATURA", "TICARIFATURA", "HKS", "KAMU"].includes(self.state.data.profileId)) {
			return (
					<SweetAlert showCancel warning
								confirmBtnText="Tamam"
								cancelBtnText="İptal"
								confirmBtnBsStyle="success"
								cancelBtnBsStyle="default"
								title="Onay"
								onConfirm={() => {
									let pre = {
										invoiceTypeInfo: {
											invoiceTypeCode: "SATIS",
											profileId: "EARSIVFATURA",
											accountingCost: null
										},
									};
								self.setPredefinedType(pre,false);
									self.setState({alert: null});
								}}
								onCancel={() => self.setState({alert: null})}>
						{externalCustomer.vknTckn} vkn/tckn numaralı {externalCustomer.formattedName} ünvanlı kullanıcı
						GİB E-Fatura listesinde kayıtlı
						değil.
						Fatura senaryo türünün E-Arşiv olarak değiştirilmesini istermisiniz?
					</SweetAlert>
			);
		}
	};

	setDocExternalCustomer(docExternalCustomer) {
		let data = deepCopyObject(this.state.data);
		data["trdDocExternalCustomer"] = docExternalCustomer;
		this.setState({data});
	}

	setConnectorExternalCustomer = (externalCustomer) => {
		let data = deepCopyObject(this.state.data);
		data["tmpDocConnectorExCustomer"] = externalCustomer;
		this.setState({data});
	}

	onChangeValue(e) {
		let data = deepCopyObject(this.state.data);
		const {name, value} = e;
		if (name === "retailCustomer") {
			if (value) {
				//data.externalCustomer = {};
				//data.externalCustomerAddress = {};
			} else {
				data.trdDocExternalCustomer = null;
			}
		}
		if (name === "isForeignCustomer") {
			data.externalCustomer={
				buyerType: null,
				city: null,
				commerceChamber: null,
				customer: null,
				customerCode: null,
				customerRiskLimit: null,
				customerType: null,
				externalCustomerAddressList: [],
				externalCustomerBankList: [],
				familyName: null,
				formattedName: null,
				givenName: null,
				initialBalance: null,
				mersisNumber: null,
				middleName: null,
				recordId: null,
				taxOffice: null,
				title: null,
				tradeRegistrationNumber: null,
				vknTckn: null};
			data.externalCustomerAddress = {
				buildingName: null,
				buildingNo: null,
				cityName: null,
				citySubdivisionName: null,
				countryName: null,
				email: null,
				fax: null,
				postalAddressRegion: null,
				postalAddressRoom: null,
				postalZone: null,
				postboxAlias: null,
				recordId: null,
				streetName: null,
				telephone: null,
				webSite: null

			};
		}

		data[name] = (name === "paymentExchangeRate" ? (new Decimal(value)).toNumber() : value);
		this.setState({data});
	}

	changeKDV(name, value) {
		let data = deepCopyObject(this.state.data);
		data[name] = value;
		this.setState({data});
	}

	setMediaViewer() {
		this.setState({url: null, mediaModal: false});
	}

	approveAsDespatch() {
		let approveAsDespatch = deepCopyObject(this.state.approveAsDespatch);
		let trdDocInvoiceNotes = deepCopyObject(this.state.data.trdDocInvoiceNotes);

		if (approveAsDespatch) {
			let found = false;
			let index;
			for (let i = 0; i < trdDocInvoiceNotes.length; i++) {
				if (trdDocInvoiceNotes[i].note.includes("İrsaliye yerine geçer.")) {
					found = true;
					index = i;
					break;
				}
			}

			if (trdDocInvoiceNotes.length >= 1) {
				if(trdDocInvoiceNotes[index].note.includes("\nİrsaliye yerine geçer."))
				trdDocInvoiceNotes[index].note = trdDocInvoiceNotes[index].note.replace(/\nİrsaliye yerine geçer./g, "")
				else {
					trdDocInvoiceNotes[index].note = "";
				}
			} else {
				let init = {};
				trdDocInvoiceNotes.splice(index, 1);
				init.note = "";
				init.recordId = null;
				trdDocInvoiceNotes.push(init);
			}

		} else {
			if (trdDocInvoiceNotes.length > 0) {
				let added = false;
				for (let i = 0; i < trdDocInvoiceNotes.length; i++) {
					if ((trdDocInvoiceNotes[i].note === "" || trdDocInvoiceNotes[i].note === null)) {
						trdDocInvoiceNotes[i].note = "İrsaliye yerine geçer.";
						added = true;
						break;
					}
				}
				if (!added) {
					let newNote = {};
					newNote.note = "İrsaliye yerine geçer.";
					trdDocInvoiceNotes.map((item, i) => {
							return item.note = item.note + "\n" + newNote.note ;
					});
				}
			}
		}
		;

		this.setState({
			data: {
				...this.state.data,
				trdDocInvoiceNotes,
			},
			approveAsDespatch: !approveAsDespatch
		})
	}

	showDocument() {
		let self = this;
		let data = deepCopyObject(self.state.data);
		let result = isValidInvoice(data, this.props.match.params.direction, this.isKamu(), this.state.activeTab, this.state.innerActiveTab, this.state.isGocIdaresi, this.props.currentUser);
		let error = result.error;
		let valid = result.valid;
		let item = data;
		if (valid) {
			let params = {
				url: "/invoiceTmp/showDocument",
				responseType: 'arraybuffer',
				method: 'post',
				data: data
			};
			self.setState({mediaModal: true, title: item.documentUuid});

			request(params)
					.then(response => {
						let blob = new Blob([response.data], {type: response.headers["content-type"]});
						let urlCreator = window.URL || window.webkitURL;
						let url = urlCreator.createObjectURL(blob);
						self.setState({url: url, saveLoading: false});
					})
					.catch(function (error) {
						self.setState({saveLoading: false});
						showAxiosError(error);
					});
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 8000
			});
			self.setState({
				error: error,
				saveLoading: false,
				activeTab: result.activeTab,
				hTabs: result.hTabs,
				innerActiveTab: result.innerActiveTab
			});
		}
	}

	handleSend(item) {
		let self = this;
		let params = {
			url: `/invoiceTmp/getPrefixCode/${item.recordId}`,
			method: 'post'
		};
		self.setState({reactLoading: true});
		request(params)
				.then(function (response) {
					let prefixCodes = response.data;
					self.setState({
						showSendSwal: true,
						prefixCodes: prefixCodes,
						documentId: prefixCodes[0].value,
						lastIssueDate: prefixCodes[0].lastIssueDate,
						item: item,
					});
				}).catch(function (error) {
			showAxiosError(error);
		}).then(function () {
			self.setState({reactLoading: false});
		});
	}

	confirmSend() {
		let self = this;
		let match = self.props.match;
		let item = self.state.item;
		let params = {
			url: `/invoiceTmp/send`,
			method: 'post',
			data: {
				recordId: item.recordId,
				documentId: this.state.documentId,
				lastIssueDate: this.state.lastIssueDate
			}
		};

		self.setState({sendBtnDisabled: true});
		request(params)
				.then(function (response) {
					self.updateInvoiceNumberWs(item.recordId);
					self.setState({showSendSwal: false, sendBtnDisabled: false, manual: true});
					Alert.success(response.data, {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});

					if (self.state.data.profileId === "EARSIVFATURA"){
						cacheInstance.delete("archive");
						self.props.history.push(`/archiveInvoice${match.params.direction}`);
					}
					else {
						cacheInstance.delete("outbox");
						self.props.history.push(`/invoice${match.params.direction}`);
					}
				}).catch(function (error) {
			self.setState({sendBtnDisabled: false, showSendSwal: false});
			showAxiosError(error);
		});
	}

	onChangeCurrency(e, label) {
		let data = deepCopyObject(this.state.data);
		data["documentCurrencyCode"] = e.value;
		if (data["documentCurrencyCode"] === "TRY") {
			this.setState({data});
			return;
		}
		let issueDate = moment(this.state.data.issueDate).format("YYYY-MM-DD");
		let options = {
			code: e.value,
			date: issueDate
		};
		let self = this;
		let params = {
			url: `/common/getCurrencyValue/${options.code}/${options.date}`,
			method: "post",
		};
		request(params)
				.then(response => {
					let forex = response.data;
					data['paymentExchangeRate'] = forex[label];
					self.setState({
						forex: forex,
						data: data,
						suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol
					});
				})
				.catch(function (error) {
					let forex = {ForexSelling: "0.00", ForexBuying: "0.00"};
					data['paymentExchangeRate'] = forex[label];
					self.setState({
						forex: forex,
						data: data,
						suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol
					});
					showAxiosError(error);
				});
	}

	onChange(e, label) {
		if (label === "ForexBuying") {
			this.setState({forexType: "Alış"});
		} else {
			this.setState({forexType: "Satış"});
		}

		let data = deepCopyObject(this.state.data);
		if (data.forex === undefined || data.forex[label] === undefined) {
			this.onChangeCurrency({value: data.documentCurrencyCode}, label);
		} else {
			data['paymentExchangeRate'] = this.state.forex[label];
			this.setState({data});
		}
	}

	onIsFree(e) {
		let data = deepCopyObject(this.state.data);
		let checked = e.target.checked;
		if (checked && data.profileId === "IHRACAT") {
			data.payableAmount = 0.00;
		} else {
			data = CreateEditInvoice.calculateTotal(data, checked);
		}
		this.setState({data: data, isFree: checked});
	}

	setTrdDocInvoiceIadeLines(trdDocInvoiceIadeLines) {
		let data = deepCopyObject(this.state.data);
		if (checkIade(data["invoiceTypeCode"])) {
			data['trdDocInvoiceIadeLines'] = trdDocInvoiceIadeLines;
		}
		this.setState({data: data});
	}

	setTrdDocInvoiceLines(trdDocInvoiceLines, medulaData, externalCustomer, externalCustomerAddress) {
		let data = deepCopyObject(this.state.data);
		data['trdDocInvoiceLines'] = trdDocInvoiceLines;
		if (medulaData) {
			let trdDocInvoiceNotes = data['trdDocInvoiceNotes'];
			let tmpDocInvoiceNotes = [];
			tmpDocInvoiceNotes.push(trdDocInvoiceNotes[0]);
			if (medulaData.type === "medikal") {
				if (medulaData.groupName && medulaData.groupName.includes("İşitme") && medulaData.groupName2 && medulaData.groupName2.includes("Yupas")) {
					tmpDocInvoiceNotes.push({
						recordId: null,
						note: "SGK_IKP:" + (medulaData.contributionAmount2 + medulaData.contributionAmount)
					});
					medulaData.contributionAmount = 0;

				} else if (medulaData.groupName && medulaData.groupName.includes("İşitme")) {
					tmpDocInvoiceNotes.push({recordId: null, note: "SGK_IKP:" + medulaData.contributionAmount});
					medulaData.contributionAmount = 0;
				}
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_HKP:" + medulaData.contributionAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_TYP:" + medulaData.type});

				if (data["invoiceTypeCode"] !== "SGK") {
					data = whenInvoiceTypeChange(data, {
						invoiceTypeCode: "SGK",
						profileId: "TEMELFATURA",
						accountingCost: "SAGLIK_MED"
					});
				}
			} else if (medulaData.type === "optik") {
				const isBasitUsul = medulaData.basitUsul && medulaData.basitUsul === true;
				let kdv;
				if (!isBasitUsul && medulaData.kdv8Amount === 0)
					kdv = new Decimal((medulaData.totalNetAmount - (medulaData.totalNetAmount / 1.10)).toFixed(2)).toNumber();
				else
					kdv = new Decimal(medulaData.kdv8Amount);

				tmpDocInvoiceNotes.push({recordId: null, note: "FATURATIPI:SGK"});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_TYP:" + medulaData.type});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_BRT:" + medulaData.totalGrossAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ISK:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_HKP:" + medulaData.totalShareAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K10:" + kdv});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K18:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MUA:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MUE:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHB:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHK:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ODE:" + medulaData.totalNetAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_DKM:" + medulaData.sgkFileNo});
				if (isBasitUsul) {
					tmpDocInvoiceNotes.push({recordId: null, note: "SGK_BASITUSUL:" + isBasitUsul});
				}

				if (data["invoiceTypeCode"] !== "SGK") {
					data = whenInvoiceTypeChange(data, {
						invoiceTypeCode: "SGK",
						profileId: "TEMELFATURA",
						accountingCost: "SAGLIK_OPT"
					});
				}

			} else if (medulaData.type === "cezaeviEczanem") {
				tmpDocInvoiceNotes.push({recordId: null, note: "FATURATIPI:SGK"});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_TYP:" + medulaData.type});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_BRT:" + medulaData.kdv8TaxableAmount});
                tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ISK:" + (medulaData.allowance + medulaData.publicAllowance + medulaData.share10And20Amount)});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_HKP:" + medulaData.share10And20Amount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K08:" + medulaData.kdv8Amount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K18:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MUA:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MUE:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ILF:" + medulaData.medicineDifferenceAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHB:" + medulaData.remuneration});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHK:" + medulaData.remunerationKdv18});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ODE:" + medulaData.totalPayablePrice});
            } else if(medulaData.type === "medikalIcmal") {
				tmpDocInvoiceNotes.push({recordId: null, note: "FATURATIPI:SGK"});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_TYP:" + medulaData.type});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_HKP:" + medulaData.contributionAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ODE:" + medulaData.totalPayableAmount});
                tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K00:" + ((medulaData.kdv0Amount && medulaData.kdv0AmountExcluded) ? new Decimal((medulaData.kdv0Amount - medulaData.kdv0AmountExcluded).toFixed(2)).toNumber() : 0)});
                tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K08:" + ((medulaData.kdv8Amount && medulaData.kdv8AmountExcluded) ? new Decimal((medulaData.kdv8Amount - medulaData.kdv8AmountExcluded).toFixed(2)).toNumber() : 0)});
                tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K10:" + ((medulaData.kdv10Amount && medulaData.kdv10AmountExcluded) ? new Decimal((medulaData.kdv10Amount - medulaData.kdv10AmountExcluded).toFixed(2)).toNumber() : 0)});
                tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K18:" + ((medulaData.kdv18Amount && medulaData.kdv18AmountExcluded) ? new Decimal((medulaData.kdv18Amount - medulaData.kdv18AmountExcluded).toFixed(2)).toNumber() : 0)});
                tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K20:" + ((medulaData.kdv20Amount && medulaData.kdv20AmountExcluded) ? new Decimal((medulaData.kdv20Amount - medulaData.kdv20AmountExcluded).toFixed(2)).toNumber() : 0)});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHK:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHB:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ISK:" + 0});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_BRT:" + medulaData.totalPayableAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_SDT:" + medulaData.startDate});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EDT:" + medulaData.endDate});

			} else {
				tmpDocInvoiceNotes.push({recordId: null, note: "FATURATIPI:SGK"});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_TYP:" + medulaData.type});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_BRT:" + medulaData.amount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ISK:" + medulaData.allowanceAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_HKP:" + medulaData.contributionAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K08:" + medulaData.kdv8Amount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K10:" + medulaData.kdv10Amount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K18:" + medulaData.kdv18Amount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_K20:" + medulaData.kdv20Amount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MUA:" + medulaData.examinationFeeS});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MUE:" + medulaData.examinationFeeH});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHB:" + medulaData.remunerationAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHK:" + medulaData.remunerationKdvAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EHK20:" + medulaData.remunerationKdvAmount20});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ODE:" + medulaData.payableAmount});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_SCL:" + medulaData.sgkMukellefKodu});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_DKM:" + medulaData.sgkFileNo});
				tmpDocInvoiceNotes.push({recordId: null, note: `SGK_PSF:${medulaData.psfMiktari === null ? 'undefined' : medulaData.psfMiktari}`});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EIP:" + medulaData.eldenIlacKatilimPayi});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MIP:" + medulaData.maastanIlacKatilimPayi});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_EMP:" + medulaData.eldenMuayeneKatilimPayi});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MMP:" + medulaData.maastanMuayeneKatilimPayi});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_ERP:" + medulaData.eldenReceteKatilimPayi});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_MRP:" + medulaData.maastanReceteKatilimPayi});
				tmpDocInvoiceNotes.push({recordId: null, note: "SGK_RCA:" + medulaData.receiptCount});

				if (!medulaData.isGocIdaresi) {
					if (data["invoiceTypeCode"] !== "SGK") {
						data = whenInvoiceTypeChange(data, {
							invoiceTypeCode: "SGK",
								profileId: "TEMELFATURA",
								accountingCost: "SAGLIK_ECZ"
						});
					}
				}

                if(medulaData.groupName && medulaData.groupName.indexOf("C Grubu Kan")  !== -1){
					let startOfMonth = moment(data.issueDate).startOf('month').format("YYYY-MM-DD");
					let middleOf15Month = moment(data.issueDate).format("YYYY-MM-15");
					let middleOf16Month = moment(data.issueDate).format("YYYY-MM-16");
					let endOfMonth = moment(data.issueDate).endOf('month').format("YYYY-MM-DD");

					let startOfPreviousMonth = moment(data.issueDate).subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
					let middleOf15PreviousMonth = moment(data.issueDate).subtract(1, 'months').format("YYYY-MM-15");
					let middleOf16PreviousMonth = moment(data.issueDate).subtract(1, 'months').format("YYYY-MM-16");
					let endOfPreviousMonth = moment(data.issueDate).subtract(1, 'months').endOf('month').format("YYYY-MM-DD");

					let day = moment(data.issueDate).format('D');
                    if(day<=10) {
						data["periodStartDate"] = middleOf16PreviousMonth;
						data["periodEndDate"] = endOfPreviousMonth;
                    }else if(day>10 && day<29){
                        data["periodStartDate"]=startOfMonth;
                        data["periodEndDate"]=middleOf15Month;
                    }else{
                        data["periodStartDate"]=null;
                        data["periodEndDate"]=null;
					}
				}
			}

			if (externalCustomer !== undefined && externalCustomerAddress !== undefined) {
				data["externalCustomer"] = externalCustomer;
				data["externalCustomerAddress"] = externalCustomerAddress;
				data["invoiceTypeCode"] = "SGK";
				data["accountingCost"] = "SAGLIK_OPT";
			}

            if(medulaData.sgkMukellefKodu)
				data['sgkMukellefKodu'] = medulaData.sgkMukellefKodu;
			if (medulaData.sgkMukellefAdi)
				data['sgkMukellefAdi'] = medulaData.sgkMukellefAdi;
			if (medulaData.sgkFileNo)
				data['sgkFileNo'] = medulaData.sgkFileNo;

			if (medulaData.issueDate) {
				let time = moment(data.issueDate).format("HH:mm:ss");
				data['issueDate'] = moment(medulaData.issueDate + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
			}
			data['trdDocInvoiceNotes'] = tmpDocInvoiceNotes;
		}
		data = CreateEditInvoice.calculateTotal(data, this.state.isFree);
		if (externalCustomer !== undefined && externalCustomerAddress !== undefined) {
			data["payableAmount"] = medulaData.totalNetAmount;
		}
		if (medulaData && medulaData.type && medulaData.type === "cezaeviEczanem") {
			data["payableAmount"] = medulaData.totalPayablePrice;
		}

		if (data.tmpDocInvoiceBrokerCosts !== null && ((data.profileId === "HKS" && data.invoiceTypeCode === "KOMISYONCU") || data.invoiceTypeCode === "HKSKOMISYONCU")) {
        	if(data.tmpDocInvoiceBrokerCosts.calculateFromPercent) {
               let method= ((data.tmpDocInvoiceBrokerCosts.isTaxInclusive===null) || (data.tmpDocInvoiceBrokerCosts.isTaxInclusive===true)) ? 'taxInclusiveAmount' : 'taxExclusiveAmount'
				data.tmpDocInvoiceBrokerCosts = this.calculateCost(data[method]);
			}
			let totalCosts = this.calculateTotalCosts(data.tmpDocInvoiceBrokerCosts);
			data['payableAmount'] = new Decimal(data['taxInclusiveAmount']).toNumber() - new Decimal(totalCosts).toNumber();
		}

		if (medulaData) {
            this.setState({data, manual: true},()=>this.updatePeriodList(data));
		} else {
			this.setState({data});
		}
	}

	getSourceUrn() {
		let userAliasList = this.state.userAliasList;
		if (userAliasList && userAliasList.length > 0) {
			this.onChangeValue({name: "sourceUrn", value: userAliasList[0].workScopecode});
		}
	}

	filterXSLTs(){
		let self = this;
		return  self.state.xslts
				.filter(xslt => (self.state.data.profileId === "EARSIVFATURA" ? xslt.xsltType === "EARSIV" : xslt.xsltType === "EFATURA"))
				.map(xslt => ({
					value: xslt.xsltFilepath,
					label: xslt.xsltFilename
				}))
	}

	getXSLT(profileId) {
		if(!profileId)
			profileId = this.state.data.profileId;

		let xslts = this.state.xslts.filter(xslt => (profileId === "EARSIVFATURA" ? xslt.xsltType==="EARSIV" : xslt.xsltType==="EFATURA"));
		let xslt = xslts.find(x => x.isDefault === 1);
		if (xslt) {
			this.onChangeValue({name: "xsltPath", value: (xslt.xsltFilepath)});
		} else {
			if (xslts && xslts instanceof Array && xslts.length > 0)
				this.onChangeValue({name: "xsltPath", value: (xslts[xslts.length - 1].xsltFilepath)});
			else
				this.onChangeValue({name: "xsltPath", value: null});
		}
	}

	renderPredefinedButtons() {
		return (
				<CardBody style={{padding: '10px 15px 0'}}>
					{
						predefinedInvoiceTypes.filter(defined => predefinedButtonFilter(defined, this.state.newPreDefined, this.props.match.params.type)).map(predefined => {
							return this.renderSinglePredefined(predefined)
						})
					}
				</CardBody>
		);
	};

	renderSinglePredefined(predefined) {
		return <Button key={predefined.value} color="info" style={{padding: '4px 8px', margin: '1px 3px'}}
					   onClick={() => this.setPredefinedType(predefined,true)}>{predefined.label}</Button>;
	};

	setPredefinedType(predefined,clearExtCustomer) {
		/*if (_.isEqual(predefined, this.state.predefinedInvoiceType)) {
			return;
		}*/
		let self = this;
		let data = deepCopyObject(self.state.data);
		if(clearExtCustomer){
			data = onSwitchExtCustomer(data,predefined.invoiceTypeInfo);
		}
		data.profileId = predefined.invoiceTypeInfo.profileId;
		data.documentTypeCode = predefined.invoiceTypeInfo.invoiceTypeCode;
		data.invoiceTypeCode = predefined.invoiceTypeInfo.invoiceTypeCode;
		data.accountingCost = predefined.invoiceTypeInfo.accountingCost;

		if (predefined.invoiceTypeInfo.retailCustomer) {
			data.retailCustomer = predefined.invoiceTypeInfo.retailCustomer;
		} else {
			if (predefined.invoiceTypeInfo.invoiceLines && predefined.invoiceTypeInfo.invoiceLines.length > 0) {
				data.trdDocInvoiceLines = predefined.invoiceTypeInfo.invoiceLines;
			}
			data.retailCustomer = false;
		}

		data = self.predefinedInvoiceType(data, predefined.invoiceTypeInfo);

		self.setState({data, isUpdateScenario: true, predefinedInvoiceType: predefined}, () => this.getXSLT(data.profileId));
	}

	fetchPredefinedInvoiceForUser(){
		let self = this;
		let params = {
			url: `/customer/fetchPredefinedInvoiceTypes`,
			method: 'post',
		};
		request(params)
			.then(function (response) {
				let newPreDefined = response.data;
				self.setState({newPreDefined})
			});
	}

	renderGekAlert() {
		//Güney ecza koop iade uyarısı
		if (EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier) {
			let self = this;
			let data = deepCopyObject(self.state.data);
			if (data) {
				let externalCustomer = data["externalCustomer"];
				let invoiceTypeCode = data["invoiceTypeCode"];
				if (externalCustomer && "7350093197" === externalCustomer.vknTckn && "IADE" === invoiceTypeCode) {
					this.setState({gekAlert: this.prepareGekAlert()});
				}
			}
		}
	}

	prepareGekAlert() {
		let self = this;
		return (<SweetAlert info
							confirmBtnText="Tamam"
							confirmBtnBsStyle="success"
							title="Bilgilendirme"
							onConfirm={() => self.setState({gekAlert: null})}>
			Lütfen Güney Ecza Koop internet şubesinden XML fatura örneği alarak iade faturanızı kesiniz
		</SweetAlert>);
	}

	async onChangeDateAndCurrency  (momentObj, name, currencyCode, forexType)  {
		await this.onChangeDate(momentObj, name);
		this.onChangeCurrency(currencyCode ? {value: currencyCode} : {value: "TRY"}, forexType && forexType === "Satış" ? "ForexSelling" :  "ForexBuying");
	}

	checkConnectorPayment(){
		return new Promise((resolve) => {
			let propType = "fatura";
			let connectorAlert = this.props.connectorAlert ? this.props.connectorAlert : false;
			let params = {
				url: `/connector/checkConnectorPayment?propType=${propType}&connectorAlert=${connectorAlert}`,
				method: "get"
			};
			request(params).then((response) => {
				let result = response.data;
				resolve(result);
			})
		});
	}

	async checkCustomaryPrice(){
		if (this.state.connectionInfo){
			let self = this;
			let result = await self.checkConnectorPayment();
			let exceptionCustomer = await self.checkConnectorPaymentExceptionCustomer();
			const propType = result.checkPropType ? result.checkPropType : [];
			this.setState({propType: result.checkPropType, checkConnectorUpdated: result.checkUpdated, checkConnectorInstallation: result.checkInstallation})

			if((propType.length === 0 && result.checkUpdated === true && result.checkInstallation === true) &&
				showConnectorPayment(EntegratorConf.identifier) && this.props.currentUser.parentCustomerWorkType === 2 &&
				this.props.currentUser.isParentCustomerDistributor && !exceptionCustomer){
				Alert.error('Bayiniz ile ödeme için görüşünüz.', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000,
					html:false
				});
			}else if((result.checkPropType != null || result.checkUpdated === true || result.checkInstallation === true ) &&
				showConnectorPayment(EntegratorConf.identifier) && !exceptionCustomer){
				this.setState({connectorPaymentModal: true});
			}else {
				self.setState({showConnectorModal: true});
			}
		}else{
			let err = {response:{data:"Konnektör Bulunamadı"}}
			showAxiosError(err);
		}
	}

	checkConnectorPaymentExceptionCustomer() {
		return new Promise((resolve) => {
			let self = this;
			let params = {
				url: "/connector/getAllConnectorPaymentExceptionCustomer",
				method: "get"
			};
			request(params).then((response) => {
				let exceptionCustomerVknTckns = response.data;
				let exceptionCustomer = connectorPaymentExceptionUser(EntegratorConf.identifier,this.props.currentUser.vknTckn,exceptionCustomerVknTckns);
				resolve(exceptionCustomer);
			})
				.catch((error) => {
					if (error.response && error.response.data) {
						Alert.error(error.response.data, {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000,
							html: false
						});
					} else {
						Alert.error("Bilinmeyen bir hata oluştu.", {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000,
							html: false
						});
					}
				});
		});
	}

	render() {
		const isCreditSufficient = this.state.isCreditSufficient!=undefined?this.state.isCreditSufficient:true;
		if (!this.state.data)
			return (<ReactLoadingTop style={{width: "90px", height: "90px"}}/>);

		return (
				<div className="row baseBackground">
					{this.state.alert}
					{this.state.gekAlert}
					{!this.state.data.deletedAt &&
					<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
							  name={"createEditInvoice"}>

						<StickButton position="leftSide"
									 title="Yeni"
									 label={this.state.saveType === "new" && this.state.saveLoading ? "Oluşturuluyor..." : "Yeni"}
									 disabled={this.state.saveLoading || (this.state.data.profileId === "EARSIVFATURA") ? !hasUserRight(UserRightsEnum.earchive.create, this.props.currentUser) : !hasUserRight(UserRightsEnum.invoice.create, this.props.currentUser) }
									 className="stickButton plus-circle"
									 onClick={(e) => this.onClickSave(e, "new")}
									 icon="plus-circle"/>

						<StickButton position="leftSide"
									 title="Goster"
									 label={this.state.saveType === "Goster" && this.state.saveLoading ? "Oluşturuluyor..." : "Fatura Göster"}
									 disabled={!isCreditSufficient || (this.state.saveLoading || (this.state.data.profileId === "EARSIVFATURA") ? !hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser) : !hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser))}
									 className="stickButton observe"
									 onClick={(e) => this.onClickSave(e, "look")}
									 icon="observe"/>

						<StickButton position="leftSide"
									 title="Direkt Gönder"
									 label={this.state.saveType === "directSend" && this.state.saveLoading ? "Gönderiliyor..." : "Direkt Gönder"}
									 disabled={!isCreditSufficient || (this.state.saveLoading || (this.state.data.profileId === "EARSIVFATURA") ? !hasUserRight(UserRightsEnum.earchive.send, this.props.currentUser) : !hasUserRight(UserRightsEnum.invoice.send, this.props.currentUser))}
									 className="stickButton send"
									 onClick={(e) => this.onClickSave(e, "directSend")}
									 icon="send"/>
						{(showConnector(EntegratorConf.identifier)  && hasUserRight(UserRightsEnum.ekonnektor.view,this.props.currentUser))&&
							<StickButton position="leftSide"
										 title="ERP'den Getir"
										 label="ERP'den Getir"
										 type="invoice"
										 className="stickButton arrow-down"
										 onClick={this.checkCustomaryPrice}
										 disabled={!isCreditSufficient || !(hasUserRight(UserRightsEnum.ekonnektor.view,this.props.currentUser))}
										 icon="arrow-down"/>
						}

						{this.state.newPreDefined !== null &&
						hasDepoIade(this.state.newPreDefined, this.props.match.params.type) && this.state.iade &&
						<DepoIade {...this.props} position={window.innerWidth < 1280 ? "seperate" : "leftSide"}
								  listener={(invoice) => {
									  let data = invoice;
									  data = CreateEditInvoice.calculateTotal(data, this.state.isFree);
									  this.setState({data, manual: true});
								  }}/>
						}


						<StickButton position="rightSide"
									 title="Kaydet"
									 label={this.state.saveType === "save" && this.state.saveLoading ? "Kaydediliyor..." : "Kaydet"}
									 disabled={this.state.saveLoading || (this.state.data.profileId === "EARSIVFATURA") ? !hasUserRight(UserRightsEnum.earchive.update, this.props.currentUser) : !hasUserRight(UserRightsEnum.invoice.update, this.props.currentUser)}
									 className="stickButton save"
									 onClick={(e) => this.onClickSave(e, "save")}
									 icon="save"/>

						<StickButton position="rightSide"
									 title="Kaydet & Kapat"
									 label={this.state.saveType === "saveClose" && this.state.saveLoading ? "Kaydediliyor..." : "Kaydet & Kapat"}
									 disabled={this.state.saveLoading || (this.state.data.profileId === "EARSIVFATURA") ? !hasUserRight(UserRightsEnum.earchive.update, this.props.currentUser) : !hasUserRight(UserRightsEnum.invoice.update, this.props.currentUser)}
									 className="stickButton terminate"
									 onClick={(e) => this.onClickSave(e, "saveClose")}
									 icon="terminate"/>
					</NavBarKS>
					}

					{this.state.data.deletedAt &&
					<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
						<StickButton position="rightSide"
									 title="Kaydet & Gönder"
									 label={this.state.saveType === "saveSend" && this.state.saveLoading ? "Gönderiliyor..." : "Kaydet & Gönder"}
									 disabled={this.state.saveLoading || (this.state.data.profileId === "EARSIVFATURA") ? !hasUserRight(UserRightsEnum.earchive.send, this.props.currentUser) : !hasUserRight(UserRightsEnum.invoice.send, this.props.currentUser)}
									 className="stickButton send"
									 onClick={(e) => this.onClickSave(e, "saveSend")}
									 icon="send"/>
					</NavBarKS>
					}
					{this.state.mediaModal &&
					<MediaViewer modal={this.state.mediaModal}
								 url={this.state.url}
								 title={this.state.title}
								 listener={this.setMediaViewer}
					/>
					}
					{this.state.showSendSwal &&
					<DefaultModal
							disabled={this.state.sendBtnDisabled}
							isOpen={this.state.showSendSwal}
							title={"Kullanmak İstediğiniz Öneki Seçiniz"}
							confirmBtnText="Gönder"
							cancelBtnText="İptal"
							onConfirm={this.confirmSend}
							onCancel={(e) => this.setState({showSendSwal: false})}
					>
						<div className="col-sm-12">
							<h5 style={{
								fontFamily: 'Century Gothic',
								fontSize: '1em',
								fontWeight: 100,
								textAlign: "center"
							}}
								className="text-danger">{this.state.documentId}</h5>
						</div>
						<div className="col-sm-12">
							<Select
									value={this.state.documentId}
									clearable={false}
									placeholder="Seçiniz..."
									noResultsText="Kayıt bulunamadı."
									onChange={(e) => this.setState({
										documentId: e.value,
										lastIssueDate: e.lastIssueDate
									})}
									options={this.state.prefixCodes.map(prefixCode => ({
										value: prefixCode.value,
										label: prefixCode.label,
										lastIssueDate: prefixCode.lastIssueDate
									}))}
							/>
						</div>
					</DefaultModal>}
					{this.state.showConnectorModal &&
						<ConnectorModal
							modal={this.state.showConnectorModal}
							type="invoice"
							modalType={'get'}
							currentUser={this.props.currentUser}
							toggleModal={(showConnectorModal, manual) => this.setState({showConnectorModal, manual})}
						/>
					}
					{this.state.customaryPriceModal &&
						<CustomaryPriceModal modal={this.state.customaryPriceModal}
											 toggle={(flag, manual) => this.setState({customaryPriceModal: flag, manual:manual})}
											 paymentInfo={this.state.paymentInfo}
											 paytrDomain={this.props.currentUser.paytrDomain}/>
					}

					{this.state.connectorPaymentModal &&
						<ConnectorPaymentModal modal={this.state.connectorPaymentModal}
											 toggle={(flag, manual) => this.setState({connectorPaymentModal: flag, manual:manual})}
											 paymentInfo={this.state.paymentInfo}
											 connectionInfo={this.state.connectionInfo}
											 propType={this.state.propType}
											 connectorAlert={this.state.connectorAlert}
											 checkConnectorUpdated={this.state.checkConnectorUpdated}
											 checkConnectorInstallation={this.state.checkConnectorInstallation}
											 currentUser={this.props.currentUser}/>
					}
					<div className="col-sm-12 satirBasi">

						{showPredefinedBtn() && this.state.newPreDefined !== null &&
						<Card style={{marginTop: '10px'}}>
							<div style={{padding: '5px 15px'}}>
								<CardSubtitle style={{margin: 0}}>Öntanımlı Fatura Tİplerİ</CardSubtitle>
							</div>

							<div style={{padding: '12px 0 10px'}}>
								{this.renderPredefinedButtons()}
							</div>
						</Card>
						}
						<div className="">
							<div className="headerTextStyle ettn" style={{fontSize: '0.9em'}}>
								<div className="row" style={{paddingLeft: "20px"}}>
									<div className="col-sm-6 col-lg-6 row" style={{paddingTop: '4px'}}> ETTN
										: {this.state.data.documentUuid}</div>

									{(this.state.data.profileId !== "EARSIVFATURA") &&
									<div className="col-sm-6 col-lg-6 row" style={{right: '-45px'}}>
										<div className="col-sm-12 col-lg-12">
											<label className='col-form-label' style={{float: 'right'}}>Gönderici Birim Etiketi:*</label>
										</div>
										<div className="col-sm-12 col-lg-12">
											<div className={"form-group" + this.validateClass('sourceUrn')}>
												<Select
														id="sourceUrn"
														clearable={false}
														style={{width: '210px', float: 'right'}}
														placeholder="Seçiniz..."
														noResultsText="Kayıt bulunamadı."
														value={this.state.data.sourceUrn || this.getSourceUrn()}
														options={this.state.userAliasList.map(alias => ({
															value: alias.workScopecode,
															label: alias.workScopecode
														}))}
														onChange={(e) => e && this.onChangeValue({
															name: "sourceUrn",
															value: e.value
														})}
												/>
											</div>
										</div>
									</div>
									}
								</div>
							</div>
						</div>
                    <div className="row">
						<div className="card-nav-tabs card-plain">
							<div className="card-header card-header-danger">
								<div className="nav-tabs-navigation">
									<div className="nav-tabs-wrapper">
										<ul className="nav tabBackground nav-tabs" data-tabs="tabs">
											<li className="nav-item">
												<a className={"nav-link " + (this.state.activeTab === 'temelbilgiler' ? 'active' : '')}
												   onClick={() => {
													   this.toggle('temelbilgiler');
												   }}
												   data-toggle="tab">Temel Bilgiler</a>
											</li>
											<li className="nav-item">
												<a className={"nav-link " + (this.state.activeTab === 'digerbilgiler' ? 'active' : '')}
												   onClick={() => {
													   this.toggle('digerbilgiler');
												   }}
												   data-toggle="tab">Diğer Bilgiler</a>
											</li>
										</ul>
										<hr></hr>
									</div>
								</div>
							</div>
							<div className="card-body">
								<div className="tab-content">
									<div className={"tab-pane " + (this.state.activeTab === 'temelbilgiler' ? 'active' : '')} id="temelbilgiler">
										<div className="col-sm-12">
                                            <div className="row baseDashboard">
                                                <div className="col-sm-7">
                                                    <div className="card-header" style={{paddingBottom: "25px"}}>
																<div className="row">
																	<div className="col-sm-4">
																		<h4 className="card-title"
																			style={{display: "inline"}}>{this.state.data.profileId === "YOLCUBERABERFATURA" ? "Turist " : (this.state.data.profileId === "IHRACAT" ? "Yabancı Firma " : (this.props.match.params.direction === "Out" ? "Alıcı " : "Müşteri "))} Bilgileri</h4>
																	</div>
																	{this.state.data.from !== "CONNECTOR" && this.state.data.profileId === "EARSIVFATURA" &&
																	<div className="col-sm-8 row">

																		<div className="col-sm-3" ></div>


																		{this.state.data.retailCustomer ?
																			<div className="col-sm-3"></div>
																			:
																			(VirtualHost.conf.resourcePrefix === "vega" ?
																					<div className="col-sm-4">
																						<label
																							style={{whiteSpace: "nowrap"}}>Yabancı
																							Müşteri</label>

																						<input type="checkbox"
																							   checked={this.state.data.isForeignCustomer}
																							   style={{float: "right"}}
																							   onChange={(e) => e && this.onChangeValue({
																								   name: "isForeignCustomer",
																								   value: e.target.checked
																							   })}/>
																					</div>
																					:
																					<div className="col-sm-3"></div>
																			)
																		}

																		{ <div className="col col-sm-9">
																			<div className="col-sm-5">
																				<label
																					style={{whiteSpace: "nowrap"}}>Yabancı
																					Müşteri</label>

																				<input type="checkbox"
																					   checked={this.state.data.isForeignCustomer}
																					   style={{float: "right"}}
																					   disabled={this.state.data.retailCustomer}
																					   onChange={(e) => e && this.onChangeValue({
																						   name: "isForeignCustomer",
																						   value: e.target.checked
																					   })}/>
																			</div>

																			{!this.state.data.isForeignCustomer &&
																				<div className="col-sm-4">
																					<label
																						style={{whiteSpace: "nowrap"}}>{
																						["eczacikart", "togb", "medikal", "isitmemerkezi", "testud", "kolaysoft", "faturam24"].includes(VirtualHost.conf.resourcePrefix) ?
																							"Şahıs Fatura" : "Perakende Müşteri"}</label>

																					<input type="checkbox"
																						   checked={this.state.data.retailCustomer}
																						   style={{float: "right"}}
																						   onChange={(e) => e && this.onChangeValue({
																							   name: "retailCustomer",
																							   value: e.target.checked
																						   })}/>
																				</div>}

																		</div>}

																	</div>
																	}
																	{this.state.data.profileId === "EARSIVFATURA" && //VirtualHost.conf.resourcePrefix === 'vega' &&
																	<div className="col-sm-6 row">
																		<div className="col-sm-4"></div>
																	</div>
																	}
																</div>
															</div>
															<div className=" ">
																<div className="card-body">
																	{(this.state.data.profileId !== "YOLCUBERABERFATURA" && this.state.data.profileId !== "IHRACAT" && !this.state.data.retailCustomer && !this.state.data.isForeignCustomer &&  this.state.data.from!=="CONNECTOR") &&
																	(<ExternalCustomer title="Müşteri Bilgileri"
																					   listener={this.setExternalCustomer}
																					   listenerAsync={this.setExternalCustomerAsync}
																					   errorListener={this.errorListener}
																					   requiredTaxOffice={false}
																					   error={this.state.error}
																					   cities={this.state.cities}
																					   countries={this.state.countries}
																					   includeForeign={false}
																					   checkGibUser={this.state.data.profileId !== "EARSIVFATURA"}
																					   docType={this.state.data.profileId !== "EARSIVFATURA" ? "EFATURA" : "EARSIVFATURA"}
																					   invoiceTypeCode={this.state.data.invoiceTypeCode}
																					   externalCustomer={this.state.data.externalCustomer}
																					   taxInclusiveAmount={this.state.data.taxInclusiveAmount}
																					   externalCustomerAddress={this.state.data.externalCustomerAddress}
																					   setPredefinedType = {this.setPredefinedType}
																					   currentUser = {this.props.currentUser}
																	/>)
																	}
																	{this.state.data.from === "CONNECTOR" && (
																		<ConnectorExternalCustomer
																			listener={this.setConnectorExternalCustomer}
																			cities={this.state.cities}
																			countries={this.state.countries}
																			externalCustomer={this.state.data.tmpDocConnectorExCustomer}
																			docType={this.state.data.profileId}
																			taxInclusiveAmount={this.state.data.taxInclusiveAmount}
																		/>
																	)}
																	{this.state.data.from !== "CONNECTOR" && this.state.data.profileId === "YOLCUBERABERFATURA" &&
																	(<TouristInfo listener={this.setTouristInfo}
																				  errorListener={this.errorListener}
																				  countries={this.state.countries}
																				  touristInfo={this.state.data.trdDocInvoiceTaxFree}
																				  error={this.state.error}/>)

																	}
																	{this.state.data.from !== "CONNECTOR" && (this.state.data.profileId === "IHRACAT" || this.state.data.isForeignCustomer) && (
																			<ForeignCompanyInfo
																					listener={this.setExternalCustomer}
																					errorListener={this.errorListener}
																					error={this.state.error}
																					includeForeign={false}
																					cities={this.state.cities}
																					countries={this.state.countries}
																					externalCustomer={this.state.data.externalCustomer}
																					externalCustomerAddress={this.state.data.externalCustomerAddress}/>)
																	}
																	{this.state.data.from !== "CONNECTOR" && this.state.data.profileId === "EARSIVFATURA" && this.state.data.retailCustomer &&
																	<NoIdentifier
																			{...this.props}
																			docExternalCustomer={this.state.data.trdDocExternalCustomer}
																			listener={this.setDocExternalCustomer}
																			countries={this.state.countries}
																			cities={this.state.cities}
																			docType={this.state.data.profileId}
																			taxInclusiveAmount={this.state.data.taxInclusiveAmount}
																	/>
																	}
																</div>
															</div>
													</div>
													<hr/>
													<div className="col-sm-5 row">
															<div className="card-header">
																<h4 className="card-title">Fatura Bilgileri</h4>
															</div>
															<div className="col-sm-12 row ">
																<div className="card-body">
																	{this.props.match.params.direction !== "Tmp" &&
																		<div className="row">
																			<label
																				className="col-sm-4 col-lg-6 col-form-label">Belge
																				Numarası*</label>
																			<div className="col-sm-8 col-lg-6">
																				<div className="form-group">
																					<input className="form-control"
																						   disabled
																						   type="text"
																						   name="documentId"
																						   value={this.state.data.documentId || ""}/>
																				</div>
																			</div>
																		</div>
																	}
																	<InvoiceType listener={this.invoiceTypeListener}
																				 manual={this.state.manual}
																				 isManual={this.isManual}
																				 profileIds={this.state.profileIds}
																				 invoiceTypeCodes={this.state.invoiceTypeCodes}
																				 profileId={this.state.data.profileId}
																				 invoiceTypeCode={this.state.data.invoiceTypeCode}
																				 accountingCost={this.state.data.accountingCost}
																				 accountingCosts={this.state.accountingCosts}
																				 gocIdaresi={this.setGocIdaresi}
																				 isUpdateScenario={this.state.isUpdateScenario}
																				 updateScenario={this.updateScenario}
																	/>
																	{this.state.data.profileId === "EARSIVFATURA" &&
																		<div className="row">
																			<label
																				className="col-sm-12 col-lg-6 col-form-label">Gönderim
																				Şekli*</label>
																			<div className="col-sm-12 col-lg-6">
																				<div
																					className={"form-group" + this.validateClass('sendingType')}>
																					<Select
																						id="sendingType"
																						clearable={false}
																						placeholder="Seçiniz..."
																						noResultsText="Kayıt bulunamadı."
																						value={this.state.data.sendingType === null ? undefined : this.state.data.sendingType}
																						onBlur={() => this.validateField({
																							target: {
																								id: "sendingType",
																								dataset: {'vlength': "1,45"},
																								value: this.state.data.sendingType
																							}
																						})}
																						options={[
																							{
																								label: "Kağıt",
																								value: "KAGIT"
																							},
																							{
																								label: "Elektronik",
																								value: "ELEKTRONIK"
																							}
																						]}
																						onChange={(e) => e && this.onChangeValue({
																							name: "sendingType",
																							value: e.value
																						})}
																					/>
																					{this.validateMessage('sendingType') !== "" &&
																						<UncontrolledTooltip
																							placement="right"
																							target="sendingType"
																							delay={0}>
																							{this.validateMessage("sendingType")}
																						</UncontrolledTooltip>}
																				</div>
																			</div>
																		</div>
																	}
																	<div className="row ">

																		<label
																			className="col-sm-12 col-lg-6 col-form-label">Düzenlenme
																			Tarihi *</label>
																		<div className="col-sm-12 col-lg-6">
																			<div
																				className={"form-group" + this.validateClass('issueDate')}>
																				<Datetime locale="tr"
																						  className="datepicker"
																						  input={true}
																						  inputProps={{id: 'issueDate'}}
																						  closeOnSelect={true}
																						  value={moment(this.state.data.issueDate)}
																						  defaultValue={moment()}
																						  dateFormat="DD-MM-YYYY"
																						  timeFormat={false}
																						  isValidDate={function (current) {
																							  return current.isBefore(Datetime.moment());
																						  }}
																						  onChange={(e) =>
																							  this.onChangeDateAndCurrency(e, "date", this.state.data.documentCurrencyCode, this.state.forexType)}/>
																				{this.validateMessage('issueDate') !== "" &&
																					<UncontrolledTooltip
																						placement="right"
																						target="issueDate"
																						delay={0}>
																						{this.validateMessage("issueDate")}
																					</UncontrolledTooltip>}
																			</div>
																		</div>
																	</div>
																	<div className="row ">

																		<label
																			className="col-sm-12 col-lg-6 col-form-label">Düzenlenme
																			Saati*</label>
																		<div className="col-sm-12 col-lg-6">
																			<div
																				className={"form-group" + this.validateClass('issueTime')}>
																				<Datetime locale="tr"
																						  className="timepicker"
																						  inputProps={{id: 'issueTime'}}
																						  input={true}
																						  value={moment(this.state.data.issueDate)}
																						  defaultValue={moment()}
																						  dateFormat={false}
																						  timeFormat={true}
																						  onChange={(e) => this.onChangeDate(e, "time")}/>
																				{this.validateMessage('issueTime') !== "" &&
																					<UncontrolledTooltip
																						placement="right"
																						target="issueTime"
																						delay={0}>
																						{this.validateMessage("issueTime")}
																					</UncontrolledTooltip>}
																			</div>
																		</div>
																	</div>
																	{this.state.data.invoiceTypeCode === "SGK" &&
																		<div className="row ">
																			<label
																				className="col-sm-12 col-lg-6 col-form-label">Dönem
																				Bilgisi</label>
																			{!this.state.manualInput &&
																				<div className="col-sm-12 col-lg-6">
																					<div
																						className={"form-group" + this.validateClass('periodStartDate')}>
																						<Select
																							id="periodStartDate"
																							clearable={false}
																							placeholder="Dönemi Seçiniz..."
																							noResultsText="Kayıt bulunamadı."
																							value={this.state.data.periodStartDate + "." + this.state.data.periodEndDate}
																							options={this.getPeriods()}
																							onChange={(e) => e && this.onChangePeriod({
																								value: e.value
																							})}
																						/>
																					</div>
																				</div>
																			}
																			{this.state.manualInput &&
																				<div
																					className={"col-sm-12 col-lg-6"}>
																					<Datetime
																						locale="tr"
																						inputProps={{id: 'manualPeriodDate'}}
																						className="datepicker"
																						timeFormat={false}
																						input={true}
																						dateFormat="YYYY/MM"
																						isValidDate={function (current) {
																							return current.isBefore(Datetime.moment());
																						}}
																						closeOnSelect={true}
																						defaultValue={" Dönem Bilgisi Girmek İçin Bir Ay Seçiniz"}
																						value={this.state.data.periodStartDate &&
																							" (" + moment(this.state.data.periodStartDate).format("DD-MM-YYYY") + ") . (" + moment(this.state.data.periodEndDate).format("DD-MM-YYYY") + ")"}
																						onChange={(e) => this.onChangeDate(e, "manualPeriodDate")}/>
																				</div>
																			}
																			{this.validateMessage('periodStartDate') !== "" &&
																				<UncontrolledTooltip
																					placement="right"
																					target="periodStartDate"
																					delay={0}>
																					{this.validateMessage("periodStartDate")}
																				</UncontrolledTooltip>}
																		</div>
																	}
																	{this.state.data.invoiceTypeCode === "SGK" &&
																		<div className="row ">
																			<label
																				className="col-sm-12 col-lg-6 col-form-label">Dönem
																				Bilgisi Manuel Giriş</label>
																			<div className="col-sm-6"
																				 style={{marginTop: '5px'}}>
																				<div className="form-group">
																					<input type="checkbox"
																						   id="manualPeriodDate"
																						   checked={this.state.manualInput}
																						   onChange={(e) => this.switchManualInput(e)}/>
																				</div>
																			</div>
																		</div>
																	}

																	{(this.state.data.invoiceTypeCode === "SARJ" || this.state.data.invoiceTypeCode === "SARJANLIK") &&
																		<div className="row ">
																			<label
																				className="col-sm-12 col-lg-6 col-form-label">Şarj
																				Başlangıç Tarihi*
																			</label>

																			<div
																				className={"col-sm-12 col-lg-6"}>
																				<Datetime locale="tr"
																						  className="datetimepicker"
																						  input={true}
																						  onBlur={(momentObj) => this.validateField({
																							  target: {
																								  id: "periodStartDateTime",
																								  dataset: {'vdata': "datetime"},
																								  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
																							  }
																						  })}
																						  inputProps={{
																							  id: 'periodStartDateTime',
																						  }}
																						  closeOnSelect={false}
																						  closeOnTab={false}
																						  value={moment(this.state.data.periodStartDateTime, "YYYY-MM-DDTHH:mm:ss.sss", true).isValid() ?
																							  moment(this.state.data.periodStartDateTime).format("DD-MM-YYYY HH:mm:ss") :
																							  (moment(this.state.data.periodStartDateTime, "YYYY-MM-DDTHH:mm:ss", true).isValid() ?
																									  moment(this.state.data.periodStartDateTime).format("DD-MM-YYYY HH:mm:ss") :
																									  this.state.data.periodStartDateTime
																							  )}
																						  dateFormat="DD-MM-YYYY"
																						  timeFormat="HH:mm:ss"
																						  isValidDate={function (current) {
																							  return current.isBefore(Datetime.moment());
																						  }}
																						  onChange={(e) => {
																							  this.onChangeDate(e, "datetime", "periodStartDateTime");
																							  document.getElementById('periodStartDateTime').readOnly = true;
																						  }}/>
																			</div>

																			{this.validateMessage('periodStartDateTime') !== "" &&
																				<UncontrolledTooltip
																					placement="right"
																					target="periodStartDateTime"
																					delay={0}>
																					{this.validateMessage("periodStartDateTime")}
																				</UncontrolledTooltip>}
																		</div>
																	}

																	<div style={{marginBottom: '6px'}}/>

																	{(this.state.data.invoiceTypeCode === "SARJ" || this.state.data.invoiceTypeCode === "SARJANLIK") &&
																		<div className="row ">
																			<label
																				className="col-sm-12 col-lg-6 col-form-label"> Şarj
																				Bitiş Tarihi*
																			</label>

																			<div
																				className={"col-sm-12 col-lg-6"}>
																				<Datetime locale="tr"
																						  className=""
																						  input={true}
																						  onBlur={(momentObj) => this.validateField({
																							  target: {
																								  id: "periodEndDateTime",
																								  dataset: {'vdata': "datetime"},
																								  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
																							  }
																						  })}
																						  inputProps={{id: 'periodEndDateTime'}}
																						  closeOnSelect={false}
																						  closeOnTab={false}
																						  value={moment(this.state.data.periodEndDateTime, "YYYY-MM-DDTHH:mm:ss.sss", true).isValid() ?
																							  moment(this.state.data.periodEndDateTime).format("DD-MM-YYYY HH:mm:ss") :
																							  (moment(this.state.data.periodEndDateTime, "YYYY-MM-DDTHH:mm:ss", true).isValid() ?
																									  moment(this.state.data.periodEndDateTime).format("DD-MM-YYYY HH:mm:ss") :
																									  this.state.data.periodEndDateTime
																							  )}
																						  dateFormat="DD-MM-YYYY"
																						  timeFormat="HH:mm:ss"
																						  isValidDate={function (now, selected) {
																							  return true;
																						  }}
																						  onChange={(e) => {
																							  this.onChangeDate(e, "datetime", "periodEndDateTime");
																							  document.getElementById('periodEndDateTime').readOnly = true;
																						  }}/>
																			</div>

																			{this.validateMessage('periodEndDateTime') !== "" &&
																				<UncontrolledTooltip
																					placement="right"
																					target="periodEndDateTime"
																					delay={0}>
																					{this.validateMessage("periodEndDateTime")}
																				</UncontrolledTooltip>}
																		</div>
																	}

																	<div style={{marginBottom: '6px'}}/>

																	<div className="row">
																		<label
																			className="col-sm-12 col-lg-6 col-form-label">Para
																			Birimi*</label>
																		<div
																			className={"col-sm-" + (this.state.data.documentCurrencyCode === "TRY" ? "12" : "12") + "  col-lg-" + (this.state.data.documentCurrencyCode === "TRY" ? "6" : "4")}>
																			<div className="form-group">
																				<Select
																					id="documentCurrencyCode"
																					clearable={false}
																					placeholder="Seçiniz..."
																					noResultsText="Kayıt bulunamadı."
																					value={this.state.data.documentCurrencyCode === null ? this.onChangeCurrency({value: "TRY"}, "ForexBuying") : this.state.data.documentCurrencyCode}
																					style={{width: "100%"}}
																					onChange={(e) => this.onChangeCurrency({value: e.value}, "ForexBuying")}
																					onBlur={() => this.validateField({
																						target: {
																							id: "documentCurrencyCode",
																							dataset: {'vlength': "1,45"},
																							value: this.state.data.documentCurrencyCode
																						}
																					})}
																					options={this.state.currencyCodes.map(currencyCode => ({
																						value: currencyCode.shortCode,
																						label: currencyCode.longCode
																					}))}
																				/>
																			</div>
																		</div>
																		{
																			this.state.data.documentCurrencyCode !== "TRY" &&
																			<div className="col-sm-12 col-lg-2" style={{
																				display: (this.state.data.documentCurrencyCode === "TRY" ? 'none' : ''),
																				padding: '0px 0px 0px 1px'
																			}}>
																				<div className="dropdown">
																					<button
																						className="btn btn-secondary dropdown-toggle"
																						type="button"
																						style={{
																							margin: 0,
																							padding: "4px 9px"
																						}}
																						id="dropdownMenuButton"
																						data-toggle="dropdown"
																						aria-haspopup="true"
																						aria-expanded="false">
																						{this.state.forexType || "Alış"}
																					</button>
																					<div className="dropdown-menu"
																						 aria-labelledby="dropdownMenuButton">
																						<a className="dropdown-item"
																						   onClick={(e) => this.onChange(e, "ForexBuying")}>Alış</a>
																						<a className="dropdown-item"
																						   onClick={(e) => this.onChange(e, "ForexSelling")}>Satış</a>
																					</div>
																				</div>
																			</div>
																		}
																	</div>
																	{
																		this.state.data.documentCurrencyCode !== "TRY" &&
																		<div className="row">
																			<label
																				className="col-sm-4 col-lg-6  col-form-label">Kur
																				Değeri *</label>
																			<div className="col-sm-8 col-lg-6">
																				<div className="form-group">
																					<NumberFormat
																						value={this.state.data.paymentExchangeRate}
																						allowNegative={false}
																						isNumericString={true}
																						thousandSeparator={'.'}
																						decimalSeparator={','}
																						suffix={this.state.suffix}
																						displayType="input"
																						isAllowed={values => {
																							return (values.value === "" ? false : true);
																						}}
																						placeholder="Kur Değeri"
																						renderText={value => {
																							value.replace(/\./g, ',')
																						}}
																						onValueChange={(e) => this.onChangeValue({
																							name: 'paymentExchangeRate',
																							value: e.value
																						})}
																						className="form-control"/>
																				</div>
																			</div>
																		</div>
																	}
																	{this.props.match.params.direction === "Tmp" &&
																		<div className="row">
																			<label
																				className="col-sm-4 col-lg-6 col-form-label">XSLT
																				Dosyası:*</label>
																			<div className="col-sm-8 col-lg-6">
																				<div
																					className={"form-group" + this.validateClass('xsltPath')}>
																					<Select
																						name="xsltPath"
																						value={this.state.data.xsltPath || this.getXSLT()}
																						clearable={false}
																						placeholder="Seçiniz..."
																						noResultsText="Kayıt bulunamadı."
																						onChange={(e) => e && this.onChangeValue({
																							name: "xsltPath",
																							value: e.value
																						})}
																						options={this.filterXSLTs()}
																					/>
																				</div>
																			</div>
																		</div>
																	}
																</div>
																<br/>
																<Row style={{
																	width: '100%',
																	marginTop: '15px',
																	marginLeft: '0px'
																}}>
																	<Col xs="1" style={{textAlign: 'left'}}>
																		<input type="checkbox"
																			   checked={this.state.approveAsDespatch}
																			   onChange={() => this.approveAsDespatch()}/>
																	</Col>

																	<Col xs="10">
																		<label>İrsaliye yerine geçer.</label>
																	</Col>
																</Row>
															</div>
													</div>
											</div>
										</div>
									</div>
									<div
										className={"tab-pane " + (this.state.activeTab === 'digerbilgiler' ? 'active' : '')}
										id="digerbilgiler">
										<div className="col-sm-12">
											<div className="row baseDashboard">
												<InformationPanel
													key={"InformationPanel"}
													manual={this.state.manual}
													isKamu={this.isKamu}
													isManual={this.isManual}
													listenerOrderReference={this.setOrderReference}
                                                    listenerDespatchReferences={this.setTrdDocInvoiceDespatchReferences}
                                                    listenerInternetSales={this.setTrdDocInvoiceInternetSales}
                                                    listenerCarrierParty={this.setTrdDocInvoiceCarrierParty}
                                                    listenertaxRepresentativeParty={this.setTrdDocInvoiceTaxRepresentativeParty}
                                                    listenerSGK={this.setSGKInfo}
                                                    listenerPayment={this.setPaymentInfo}
                                                    listenerClearPayment={this.clearPaymentInfo}
                                                    listenerCosts={this.costsListener}
                                                    listenerAdditionalInformation={this.setAdditionalInformation}
                                                    despatchReferences={this.state.data.trdDocInvoiceDespatchReferences}
                                                    saleTypes={this.state.saleTypes}
                                                    cities={this.state.cities}
                                                    paymentMeansCodes={this.state.paymentMeansCodes}
                                                    paymentChannelCodes={this.state.paymentChannelCodes}
                                                    internetSales={(this.state.data.trdDocInvoiceInternetSales)}
                                                    orderReference={{
                                                        orderReferenceNumber: this.state.data.orderReferenceNumber,
                                                        orderReferenceDate: this.state.data.orderReferenceDate,
														orderManager: this.state.data.orderManager
                                                    }}
                                                    errorListener={this.errorListener}
                                                    invoiceTypeCode={this.state.data.invoiceTypeCode}
                                                    profileId={this.state.data.profileId}
                                                    accountingCost={this.state.data.accountingCost}
                                                    paymentInfo={{
                                                        paymentChannelCode: this.state.data.paymentChannelCode,
                                                        paymentMeansCode: this.state.data.paymentMeansCode,
                                                        paymentFinancialAccountId: this.state.data.paymentFinancialAccountId,
														instructionNote: this.state.data.instructionNote,
														paymentFormattedName: this.state.data.paymentFormattedName,
														paymentVkn: this.state.data.paymentVkn,
														paymentCity: this.state.data.paymentCity,
														paymentCountry: this.state.data.paymentCountry
                                                    }}
                                                    sgkInfo={{
                                                        sgkMukellefAdi: this.state.data.sgkMukellefAdi,
                                                        sgkMukellefKodu: this.state.data.sgkMukellefKodu,
                                                        sgkFileNo: this.state.data.sgkFileNo
                                                    }}
                                                    carrierParty={{
                                                        carrierPartyFamilyName: this.state.data.carrierPartyFamilyName,
                                                        carrierPartyFirstName: this.state.data.carrierPartyFirstName,
                                                        carrierPartyId: this.state.data.carrierPartyId,
                                                        carrierPartyName: this.state.data.carrierPartyName,
                                                        actualDeliveryDate: this.state.data.actualDeliveryDate
                                                    }}
                                                    taxRepresentativeParty={this.state.data.trdDocInvoiceTaxFree}
                                                    error={this.state.error}
                                                    activeTabListener={(activeTab) => this.setState({innerActiveTab: activeTab})}
                                                    activeTab={this.state.innerActiveTab}
                                                    documentId={this.props.match.params.recordId}
                                                    brokerCosts={this.state.data.tmpDocInvoiceBrokerCosts}
                                                    taxInclusiveAmount={this.state.data.taxInclusiveAmount}
                                                    taxExclusiveAmount={this.state.data.taxExclusiveAmount}
													showOrderManagerLineNum={this.state.showOrderManagerLineNum}
													externalCustomer={this.state.data.externalCustomer}
													externalCustomerAddress={this.state.data.externalCustomerAddress}
													type={this.props.match.params.type }
													additionalDocuments={this.state.additionalDocuments}
													invoiceTypeCodes = {this.state.invoiceTypeCode}
													loadingBank={this.setLoadingBank}
													setAdditionalDocument={this.setAdditionalDocument}
													isGocIdaresi={this.state.isGocIdaresi}
													additionalInformation={{
														imei:this.state.data.imei,
														mac:this.state.data.mac,
														paymentDueDate: this.state.data.paymentDueDate,
														aracKimlikNo:this.state.data.aracKimlikNo,
														plakaNo:this.state.data.plakaNo,
														esuRaporId:this.state.data.esuRaporId,
														esuRaporIdIssueDate:this.state.data.esuRaporIdIssueDate,
													}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
						{checkIade(this.state.data.invoiceTypeCode)  &&
							<div className="col-sm-12 baseDashboard" style={{marginTop:'10px'}}>
								<InvoiceIadeLine listener={this.setTrdDocInvoiceIadeLines}
												 currentUser={this.props.currentUser}
												 data={this.state.data.trdDocInvoiceIadeLines}
								/>
							</div>
						}

                    <div className="col-sm-12 baseDashboard" style={{marginTop: (this.state.iade || checkIade(this.state.data.invoiceTypeCode)) ? '10px' : '-5px'}}>
                        <InvoiceLines listener={this.setTrdDocInvoiceLines}
                                      manual={this.state.manual}
                                      isKamu={this.isKamu}
                                      isManual={this.isManual}
                                      errorListener={this.errorListener}
                                      isCreate={this.props.match.params.recordId === 0 ? true : false}
                                      direction={this.props.match.params.direction}
                                      error={this.state.error}
                                      suffix={this.state.suffix}
                                      trdDocInvoiceLines={this.state.data.trdDocInvoiceLines}
                                      profileId={this.state.data.profileId}
                                      accountingCost={this.state.data.accountingCost}
                                      invoiceTypeCode={this.state.data.invoiceTypeCode}
                                      withholdingTypes={this.state.withholdingTypes}
                                      charges={this.state.charges}
                                      unitCodes={this.state.unitCodes}
                                      currencyCodes={this.state.currencyCodes}
                                      exemptions={this.state.exemptions}
                                      countries={this.state.countries}
                                      documentCurrencyCode={this.state.data.documentCurrencyCode}
                                      packageTypeCodes={this.state.packageTypeCodes}
                                      deliveryTermsCodes={this.state.deliveryTermsCodes}
                                      transportMeansTypeCodes={this.state.transportMeansTypeCodes}
                                      transportModeCodes={this.state.transportModeCodes}
                                      classificationTypes={this.state.classificationTypes}
                                      gocIdaresi={this.setGocIdaresi}
									  showOrderManagerLineNum={this.state.showOrderManagerLineNum}
									  currentUser={this.props.currentUser}
									  vknTckn={this.state.data.externalCustomer && this.state.data.externalCustomer.vknTckn ? this.state.data.externalCustomer.vknTckn : ""}
                        />
                    </div>

                    <div className="col-sm-12" style={{marginTop: '10px'}}>
                        <div className="row baseDashboard">
                            <div className="col-sm-7">
                                <div className="card-header  ">
                                    <h4 className="card-title">Açıklama</h4>
                                </div>
                                <div className="card-body">
                                    <NoteList
                                        manual={this.state.manual}
                                        isManual={this.isManual}
                                        listener={this.setTrdDocInvoiceNotes}
                                        errorListener={this.errorListener}
                                        error={this.state.error}
                                        rows={7}
                                        notes={this.state.data.trdDocInvoiceNotes}/>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="col-sm-5 row">
                                <div className="card-header">
                                    <h4 className="card-title">Toplamlar</h4>
                                </div>
                                <div className="col-sm-12">
                                    <div className="card-body">
                                        <TotalList suffix={this.state.suffix}
                                                   lines={this.state.data.trdDocInvoiceLines}
                                                   totalKdv0Amount={this.state.data.totalKdv0Amount}
                                                   totalKdv1Amount={this.state.data.totalKdv1Amount}
                                                   totalKdv8Amount={this.state.data.totalKdv8Amount}
                                                   totalKdv10Amount={this.state.data.totalKdv10Amount}
                                                   totalKdv18Amount={this.state.data.totalKdv18Amount}
                                                   totalKdv20Amount={this.state.data.totalKdv20Amount}
                                                   isManual={this.state.data.isManual}
                                                   chargesName={"trdDocInvoiceLineCharges"}
                                                   showKDV={this.state.invoiceTypeCode !== 'TEVKIFATIADE' ? true : false}
                                                   showATA={true}
                                                   type="invoice"
                                                   changeKDV={this.changeKDV}
                                                   lineExtensionAmount={this.state.data.lineExtensionAmount}
                                                   taxExclusiveAmount={this.state.data.taxExclusiveAmount}
                                                   taxInclusiveAmount={this.state.data.taxInclusiveAmount}
                                                   payableAmount={this.state.data.payableAmount}
                                                   totalCosts={this.state.totalCosts}
                                                   showTotalCosts={(this.state.data.profileId === "HKS" && this.state.data.invoiceTypeCode === "KOMISYONCU") || this.state.data.invoiceTypeCode === "HKSKOMISYONCU"}
                                                   isExport={(this.state.data.profileId === "IHRACAT")}
												   invoiceTypeCode={this.state.data.invoiceTypeCode}
                                        />
                                        {this.state.data.profileId === "IHRACAT" &&
                                        <div className="row">
                                            <label className="col-sm-6 col-form-label">Bedelsiz İhracat</label>
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <input type="checkbox" checked={this.state.isFree}
                                                           onChange={this.onIsFree}/>
                                                </div>
                                            </div>
                                        </div>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.saveLoading || this.state.loadingBank && <ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
            </div>
        );
    }
}

export default CreateEditInvoice;
